<template>
  <div
    class="py-4 container-fluid"
    @touchstart.passive="onSwipeStart"
    @touchend.passive="onSwipeEnd"
  >
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0 d-flex align-items-center" :class="{ 'flex-column align-items-stretch': isMobileDevice }">
            <div :class="{ 'w-100 mb-2': isMobileDevice }">
              <h6 class="mb-1">
                Detalle del Pedido
                <span v-if="order" class="text-primary ms-1">{{ orderLabel({ ...order, source: order.source || $route.query.source || 'shopify' }) }}</span>
              </h6>
              <span v-if="order" class="badge badge-sm" :class="currentStatusBadgeClass">
                {{ currentStatus }}
              </span>
            </div>
            <div class="d-flex align-items-center gap-2" :class="isMobileDevice ? 'flex-wrap' : 'ms-auto'">
              
              <button
                v-if="order && lineItems.length"
                class="btn btn-primary btn-sm"
                @click="startPicking"
              >
                <i class="fas fa-box-open me-1"></i> Picking Packing
              </button>
              <button
                v-if="order && (isOrderPrepared || currentStatus === 'APROBADO ENVIO') && !hasWaybill && !isVeOrder"
                class="btn btn-success btn-sm"
                @click="openShippingModal"
              >
                <i class="fas fa-truck me-1"></i> Generar ticket de envío
              </button>
              <button
                v-if="order && isVeOrder && isOrderPrepared && !isOrderDispatched"
                class="btn btn-warning btn-sm"
                :disabled="isMarkingDispatched"
                @click="markAsDispatched"
              >
                <i class="fas fa-spinner fa-spin me-1" v-if="isMarkingDispatched"></i>
                <i class="fas fa-check-circle me-1" v-else></i>
                Marcar como despachado
              </button>
              <button
                v-if="order && !isVeOrder && currentStatus === 'DESPACHADO'"
                class="btn btn-success btn-sm"
                :disabled="!!changingShippingStatus"
                @click="changeShippingStatus('ENTREGADO')"
              >
                <i class="fas fa-spinner fa-spin me-1" v-if="changingShippingStatus === 'ENTREGADO'"></i>
                <i class="fas fa-flag-checkered me-1" v-else></i>
                Marcar como entregado
              </button>
              <button
                v-if="order && hasWaybill && !isVeOrder"
                class="btn btn-info btn-sm"
                @click="printWaybill"
                :disabled="isPrintingWaybill"
              >
                <i class="fas fa-print me-1" v-if="!isPrintingWaybill"></i>
                <i class="fas fa-spinner fa-spin me-1" v-if="isPrintingWaybill"></i>
                Imprimir rótulo
              </button>
              <button
                v-if="order && isVeOrder"
                class="btn btn-sm"
                :class="order.kubapp_invoiced_at ? 'btn-outline-success' : 'btn-success'"
                :disabled="isMarkingInvoiced"
                @click="toggleInvoiced"
                :title="order.kubapp_invoiced_at
                  ? `Facturado el ${formatDate(order.kubapp_invoiced_at)}. Clic para quitar la marca`
                  : 'Marcar como facturado'"
              >
                <i class="fas fa-spinner fa-spin me-1" v-if="isMarkingInvoiced"></i>
                <i class="fas fa-file-invoice me-1" v-else></i>
                {{ order.kubapp_invoiced_at ? 'Facturado' : 'Marcar facturado' }}
              </button>
              <button class="btn btn-link btn-sm p-0 text-secondary" @click="goBack">
                <i class="fas fa-arrow-left me-1"></i> Volver
              </button>
            </div>
          </div>
          <div class="card-body">
            <div v-if="isLoading" class="text-center py-4">
              <i class="fas fa-spinner fa-spin me-1"></i> Cargando...
            </div>
            <div v-else-if="!order" class="text-center py-4 text-muted">
              No se encontró el pedido.
            </div>
            <div v-else>
              <div class="row g-2 mb-4">
                <div :class="isVeOrder ? 'col-lg-6' : 'col-lg-4'">
                  <div class="border rounded p-3 h-100">
                    <div
                      class="text-xs text-uppercase text-secondary font-weight-bolder d-flex align-items-center"
                      :class="{ 'mb-2': isCardOpen('info'), 'card-toggle': isMobileDevice }"
                      @click="toggleCard('info')"
                    >
                      <span><i class="fas fa-receipt me-1"></i> Información del pedido</span>
                      <i v-if="isMobileDevice" class="fas ms-auto" :class="isCardOpen('info') ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </div>
                    <div v-show="isCardOpen('info')" class="order-info-grid">
                      <div>
                        <span class="order-info-label">Orden</span>
                        <span class="text-sm font-weight-bold">{{ orderLabel(order) }}</span>
                      </div>
                      <div>
                        <span class="order-info-label">Origen</span>
                        <span class="text-sm">{{ order.source === 'shopify' ? 'Shopify' : (order.source === 'shopify-ve' ? 'Shopify Vzla' : 'POS') }}</span>
                      </div>
                      <div>
                        <span class="order-info-label">Fecha</span>
                        <span class="text-sm">{{ formatDate(order.shopify_created_at || order.synced_at || order.created_at) }}</span>
                      </div>
                      <div>
                        <span class="order-info-label">Moneda</span>
                        <span class="text-sm">{{ order.currency || '—' }}</span>
                      </div>
                      <div>
                        <span class="order-info-label">Estado financiero</span>
                        <span class="text-sm">{{ order.financial_status || '—' }}</span>
                      </div>
                      <div>
                        <span class="order-info-label">Estado envío</span>
                        <span class="text-sm">{{ order.fulfillment_status || '—' }}</span>
                      </div>
                      <div>
                        <span class="order-info-label">Método de pago</span>
                        <span class="text-sm">{{ order.payment_method || '—' }}</span>
                      </div>
                      <div v-if="isVeOrder">
                        <span class="order-info-label">Factura Kubapp</span>
                        <span
                          v-if="order.kubapp_invoiced_at"
                          class="badge badge-sm bg-gradient-success"
                          :title="formatDate(order.kubapp_invoiced_at)"
                        >
                          <i class="fas fa-check me-1"></i>{{ formatDate(order.kubapp_invoiced_at) }}
                        </span>
                        <span v-else class="text-sm text-secondary">—</span>
                      </div>
                      <div v-if="order.note" class="order-info-full">
                        <span class="order-info-label">Nota</span>
                        <span class="text-sm">{{ order.note }}</span>
                      </div>
                      <div v-if="order.tags" class="order-info-full">
                        <span class="order-info-label">Etiquetas</span>
                        <span class="text-sm">{{ order.tags }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div :class="isVeOrder ? 'col-lg-6' : 'col-lg-4'">
                  <div class="border rounded p-3 h-100 bg-light">
                    <div class="d-flex align-items-center" :class="{ 'mb-3': isCardOpen('location') }">
                      <div
                        class="text-xs text-uppercase text-secondary font-weight-bolder"
                        :class="{ 'card-toggle flex-grow-1': isMobileDevice }"
                        @click="toggleCard('location')"
                      >
                        <i class="fas fa-map-marker-alt me-1"></i> Ubicación del cliente
                        <i v-if="isMobileDevice" class="fas ms-1" :class="isCardOpen('location') ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                      </div>
                      <button
                        v-if="!isVeOrder"
                        class="btn btn-link btn-sm p-0 m-0 ms-auto text-secondary"
                        @click="openCustomerEditModal"
                        title="Editar cliente"
                      >
                        <i class="fas fa-user-edit"></i>
                      </button>
                      <button
                        v-if="order.shipping_address && !isVeOrder"
                        class="btn btn-link btn-sm p-0 m-0 ms-3 text-secondary"
                        @click="openAddressEditModal"
                        title="Editar dirección completa"
                      >
                        <i class="fas fa-pencil-alt"></i>
                      </button>
                    </div>
                    <div v-show="isCardOpen('location')">
                    <div class="text-xs location-info-row"><strong>Nombre:</strong> {{ shippingCustomerName }}</div>
                    <div class="text-xs location-info-row"><strong>Dirección:</strong> {{ order.shipping_address?.address1 || '—' }}</div>
                    <div v-if="order.shipping_address?.address2" class="text-xs location-info-row"><strong>Dirección 2:</strong> {{ order.shipping_address.address2 }}</div>
                    <div class="text-xs location-info-row"><strong>Ciudad:</strong> {{ order.shipping_address?.city || '—' }}</div>
                    <div class="text-xs location-info-row"><strong>Departamento:</strong> {{ order.shipping_address?.province || '—' }}</div>
                    <div class="text-xs location-info-row"><strong>Código postal:</strong> {{ order.shipping_address?.zip || '—' }}</div>
                    <div class="text-xs location-info-row"><strong>Teléfono:</strong> {{ order.shipping_address?.phone || order.customer?.phone || '—' }}</div>
                    <div class="text-xs location-info-row mb-0"><strong>Email:</strong> {{ order.email || '—' }}</div>
                    </div>
                  </div>
                </div>
                <div v-if="!isVeOrder" class="col-lg-4">
                  <div class="border rounded p-2 h-100">
                    <div
                      class="text-xs text-uppercase text-secondary font-weight-bolder d-flex align-items-center"
                      :class="{ 'mb-2': isCardOpen('shipping'), 'card-toggle': isMobileDevice }"
                      @click="toggleCard('shipping')"
                    >
                      <span><i class="fas fa-calculator me-1"></i> Datos del cálculo de envío</span>
                      <i v-if="isMobileDevice" class="fas ms-auto" :class="isCardOpen('shipping') ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </div>
                    <div v-show="isCardOpen('shipping')">
                    <label class="text-xs text-secondary mb-0">Dirección</label>
                    <input v-model="shippingForm.address" class="form-control form-control-sm mb-1" placeholder="Dirección de envío" />
                    <div class="row g-1">
                      <div class="col-6">
                        <label class="text-xs text-secondary mb-0">Ciudad</label>
                        <select v-model="shippingForm.city" class="form-select form-select-sm mb-1">
                          <option value="" disabled>Seleccione...</option>
                          <option v-if="cityNotInList" :value="shippingForm.city">{{ shippingForm.city }} (no está en la lista)</option>
                          <option v-for="c in shippingCities" :key="c" :value="c">{{ c }}</option>
                        </select>
                      </div>
                      <div class="col-6">
                        <label class="text-xs text-secondary mb-0">Departamento</label>
                        <select v-model="shippingForm.province" @change="onShippingProvinceChange" class="form-select form-select-sm mb-1">
                          <option value="" disabled>Seleccione...</option>
                          <option v-if="provinceNotInList" :value="shippingForm.province">{{ shippingForm.province }} (no está en la lista)</option>
                          <option v-for="d in shippingDepartments" :key="d" :value="d">{{ d }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="row g-1">
                      <div class="col-4">
                        <label class="text-xs text-secondary mb-0">Código postal</label>
                        <input v-model="shippingForm.zip" class="form-control form-control-sm mb-1" placeholder="ZIP" />
                      </div>
                      <div class="col-4">
                        <label class="text-xs text-secondary mb-0">Teléfono</label>
                        <input v-model="shippingForm.phone" class="form-control form-control-sm mb-1" placeholder="Teléfono" />
                      </div>
                      <div class="col-4">
                        <label class="text-xs text-secondary mb-0">Cédula/NIT</label>
                        <input v-model="shippingForm.company" class="form-control form-control-sm mb-1" placeholder="Cédula/NIT" />
                      </div>
                    </div>
                    <div class="row g-1">
                      <div class="col-3">
                        <label class="text-xs text-secondary mb-0">Peso (kg)</label>
                        <input v-model="packageForm.weight" type="number" min="0.01" step="0.01" class="form-control form-control-sm mb-1" />
                      </div>
                      <div class="col-3">
                        <label class="text-xs text-secondary mb-0">Largo (cm)</label>
                        <input v-model="packageForm.length" type="number" min="1" step="1" class="form-control form-control-sm mb-1" />
                      </div>
                      <div class="col-3">
                        <label class="text-xs text-secondary mb-0">Ancho (cm)</label>
                        <input v-model="packageForm.width" type="number" min="1" step="1" class="form-control form-control-sm mb-1" />
                      </div>
                      <div class="col-3">
                        <label class="text-xs text-secondary mb-0">Alto (cm)</label>
                        <input v-model="packageForm.height" type="number" min="1" step="1" class="form-control form-control-sm mb-1" />
                      </div>
                    </div>
                    <div class="text-xxs text-secondary">
                      Calculado: {{ defaultPackageWeight }} kg (0.3 kg por prenda)
                      <a v-if="isPackageFormModified" href="#" class="ms-1" @click.prevent="initPackageForm">Restablecer</a>
                    </div>
                    <div v-if="waybillPackage" class="text-xxs mt-1" :class="isPackageFormModified ? 'text-warning' : 'text-success'">
                      <i class="fas me-1" :class="isPackageFormModified ? 'fa-exclamation-triangle' : 'fa-check-circle'"></i>
                      Guía generada con: {{ waybillPackage.weight }} kg ·
                      {{ waybillPackage.length }} × {{ waybillPackage.width }} × {{ waybillPackage.height }} cm
                      <span v-if="isPackageFormModified">(los valores actuales son distintos)</span>
                    </div>
                    <button
                      class="btn btn-primary btn-sm w-100 mt-2 mb-0"
                      type="button"
                      @click="saveShippingForm"
                      :disabled="isSavingShippingForm || !isShippingFormDirty"
                    >
                      <i class="fas me-1" :class="isSavingShippingForm ? 'fa-spinner fa-spin' : 'fa-save'"></i>
                      Guardar en el pedido
                    </button>
                    <div v-if="isRestrictedShippingCity" class="border-top mt-2 pt-2">
                      <div class="mb-1">
                        <input id="localDeliveryToggle" v-model="localDeliveryForm.enabled" type="checkbox" />
                        <label class="text-xs ms-1 mb-0" for="localDeliveryToggle">
                          <i class="fas fa-motorcycle me-1"></i> Envío local
                        </label>
                      </div>
                      <div v-if="localDeliveryForm.enabled" class="row g-1">
                        <div class="col-7">
                          <label class="text-xs text-secondary mb-0">Mensajero</label>
                          <select v-model="localDeliveryForm.user_id" class="form-select form-select-sm mb-1">
                            <option :value="null" disabled>Seleccione...</option>
                            <option v-for="u in localDeliveryUsers" :key="u.id" :value="u.id">{{ u.name }}</option>
                          </select>
                        </div>
                        <div class="col-5">
                          <label class="text-xs text-secondary mb-0">Valor pagado</label>
                          <input v-model="localDeliveryForm.amount" type="number" min="0" step="any" class="form-control form-control-sm mb-1" placeholder="0" />
                        </div>
                      </div>
                      <button
                        class="btn btn-outline-primary btn-sm w-100 mt-1 mb-0"
                        type="button"
                        @click="saveLocalDelivery"
                        :disabled="isSavingLocalDelivery || !isLocalDeliveryDirty
                          || (localDeliveryForm.enabled && !localDeliveryForm.user_id)"
                      >
                        <i class="fas me-1" :class="isSavingLocalDelivery ? 'fa-spinner fa-spin' : 'fa-save'"></i>
                        Guardar envío local
                      </button>
                    </div>
                    </div>
                    <button
                      v-if="currentStatus === 'PREPARADO' && !isRestrictedShippingCity"
                      class="btn btn-dark btn-sm w-100 mt-2 mb-0"
                      type="button"
                      :disabled="!!changingShippingStatus || isShippingFormDirty"
                      @click="changeShippingStatus('APROBADO ENVIO')"
                      :title="isShippingFormDirty
                        ? 'Guarda los cambios de envío antes de aprobar'
                        : 'Aprobar para que la aplicación de guías genere el ticket de envío'"
                    >
                      <i class="fas fa-spinner fa-spin me-1" v-if="changingShippingStatus === 'APROBADO ENVIO'"></i>
                      <i class="fas fa-thumbs-up me-1" v-else></i>
                      Aprobar para envío
                    </button>
                    <p v-if="currentStatus === 'PREPARADO' && isShippingFormDirty && !isRestrictedShippingCity" class="text-xxs text-warning mb-0 mt-1">
                      Guarda los cambios antes de aprobar.
                    </p>
                    <button
                      v-if="['APROBADO ENVIO', 'GUIA GENERADA'].includes(currentStatus)
                        || (currentStatus === 'PREPARADO' && isRestrictedShippingCity)"
                      class="btn btn-warning btn-sm w-100 mt-2 mb-0"
                      type="button"
                      :disabled="!!changingShippingStatus"
                      @click="changeShippingStatus('DESPACHADO')"
                    >
                      <i class="fas fa-spinner fa-spin me-1" v-if="changingShippingStatus === 'DESPACHADO'"></i>
                      <i class="fas fa-check-circle me-1" v-else></i>
                      Marcar como despachado
                    </button>
                    <p v-if="currentStatus === 'PREPARADO' && isRestrictedShippingCity" class="text-xxs text-secondary mb-0 mt-1">
                      <i class="fas fa-info-circle me-1"></i>
                      {{ order.shipping_address?.city }} no lleva guía de envío: se despacha directamente.
                    </p>
                  </div>
                </div>
              </div>

              <div class="d-flex align-items-center mb-2">
                <h6 class="text-uppercase text-secondary text-xxs font-weight-bolder mb-0">Productos</h6>
                <button
                  v-if="canEditItems"
                  class="btn mb-0 btn-outline-warning btn-sm ms-auto"
                  type="button"
                  title="Cambiar o agregar productos antes de sincronizar con Shopify"
                  @click="$router.push({ name: 'Shopify Order Edit', query: { id: order.id } })"
                >
                  <i class="fas fa-pencil-alt me-1" aria-hidden="true"></i>Editar productos
                </button>
                <button
                  v-if="isVeOrder && hasVenezuelaItems"
                  class="btn mb-0 btn-outline-secondary btn-sm ms-auto"
                  type="button"
                  @click="copyVeItemsForExcel"
                  title="Copiar ítems VZL para crear la factura en Kubapp Venezuela"
                >
                  <i class="fas fa-copy me-1" aria-hidden="true"></i>Sinc Venezuela
                </button>
                <button
                  v-if="isVeOrder && hasColombiaItems && !hasKubappSync"
                  class="btn mb-0 btn-sm ms-2"
                  :class="order?.kubapp_invoiced_at ? 'btn-outline-success' : 'btn-outline-secondary'"
                  type="button"
                  :disabled="isSyncingKubapp"
                  @click="syncOrderToKubapp"
                  :title="order?.kubapp_invoiced_at
                    ? `Factura registrada el ${formatDate(order.kubapp_invoiced_at)}. Volver a sincronizar con Kubapp Colombia`
                    : 'Sincronizar factura de venta con Kubapp Colombia'"
                >
                  <i class="fas fa-sync-alt me-1" :class="{ 'fa-spin': isSyncingKubapp }" aria-hidden="true"></i>Sincronizar con Kubapp Colombia
                </button>
                <span
                  v-else-if="isVeOrder && hasKubappSync"
                  class="badge badge-sm bg-gradient-success ms-2 align-self-center"
                  :title="order?.kubapp_invoiced_at
                    ? `Factura de venta registrada en Kubapp Colombia el ${formatDate(order.kubapp_invoiced_at)}`
                    : 'Factura de venta registrada en Kubapp Colombia'"
                >
                  <i class="fas fa-check me-1" aria-hidden="true"></i>Ya sincronizado
                </span>
              </div>
              <div class="table-responsive">
                <table class="table align-items-center mb-0" :class="{ 'order-items-table-mobile': isMobileDevice }">
                  <thead>
                    <tr>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producto</th>
                      <th v-if="isVeOrder" class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Origen</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cantidad</th>
                      <th v-if="isVeOrder" class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Costo</th>
                      <th v-if="isVeOrder" class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio COP</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, idx) in lineItems" :key="idx">
                      <td>
                        <span class="text-sm font-weight-bold d-block">{{ item.title || item.name || '—' }}</span>
                        <span v-if="item.variant_title" class="text-xs text-secondary">{{ item.variant_title }}</span>
                        <span v-if="item.sku" class="text-xs text-secondary d-block">SKU: {{ item.sku }}</span>
                      </td>
                      <td v-if="isVeOrder" class="text-center">
                        <span
                          v-if="item.origin"
                          class="badge"
                          :class="item.origin === 'COP' ? 'bg-info' : 'bg-danger'"
                        >
                          {{ item.origin }}
                        </span>
                        <span v-else class="text-xs text-secondary">—</span>
                      </td>
                      <td class="text-center text-sm">{{ item.quantity || 1 }}</td>
                      <td v-if="isVeOrder" class="text-center text-sm">{{ item.cost != null ? formatNumber(item.cost) : '—' }}</td>
                      <td v-if="isVeOrder" class="text-center text-sm">{{ itemPriceCop(item) }}</td>
                      <td class="text-center text-sm">{{ formatMoney(itemPrice(item), order.currency) }}</td>
                      <td class="text-center text-sm">{{ formatMoney(itemTotal(item), order.currency) }}</td>
                      <td class="text-center">
                        <span
                          class="badge"
                          :class="getItemPickingStatus(item) === 'picked' ? 'bg-success' : 'bg-warning text-dark'"
                        >
                          {{ getItemPickingStatus(item) === 'picked' ? 'Preparado' : 'Pendiente' }}
                        </span>
                      </td>
                    </tr>
                    <tr v-if="!lineItems.length">
                      <td :colspan="isVeOrder ? 8 : 5" class="text-center text-muted text-xs">Sin productos</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="row mt-4">
                <div class="col-md-6 offset-md-6">
                  <table class="table table-sm">
                    <tbody>
                      <tr>
                        <td class="text-secondary text-xs">Subtotal</td>
                        <td class="text-sm text-end">{{ formatMoney(order.subtotal_price, order.currency) }}</td>
                      </tr>
                      <tr>
                        <td class="text-secondary text-xs">Impuestos</td>
                        <td class="text-sm text-end">{{ formatMoney(order.total_tax, order.currency) }}</td>
                      </tr>
                      <tr>
                        <td class="text-secondary text-xs">Descuentos</td>
                        <td class="text-sm text-end">{{ formatMoney(order.total_discounts, order.currency) }}</td>
                      </tr>
                      <tr>
                        <td class="text-sm font-weight-bold">Total</td>
                        <td class="text-sm font-weight-bold text-end">{{ formatMoney(order.total_price, order.currency) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de escaneo con cámara (picking en móvil) -->
    <div v-if="isCameraScanning" class="scanner-modal-overlay" @click.self="stopCameraScanner">
      <div class="scanner-modal card shadow">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0">Escanear código de barras</h6>
            <button type="button" class="btn-close" @click="stopCameraScanner"></button>
          </div>
          <div class="scanner-video-wrapper">
            <video ref="scannerVideo" autoplay playsinline muted></video>
            <div class="scanner-guide"></div>
          </div>
          <div v-if="torchAvailable" class="text-center mt-2">
            <button type="button" class="btn btn-sm mb-0" :class="torchOn ? 'btn-warning' : 'btn-outline-secondary'" @click="toggleTorch">
              <i class="fas fa-lightbulb me-1"></i>{{ torchOn ? 'Apagar linterna' : 'Linterna' }}
            </button>
          </div>
          <p class="text-xs text-muted text-center mt-2 mb-0">Apunta la cámara al código de barras del producto</p>
          <button type="button" class="btn btn-secondary w-100 mt-3 mb-0" @click="stopCameraScanner">
            <i class="fas fa-times me-1"></i>Cerrar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Picking Packing -->
    <div v-if="showPickingModal" class="picking-modal-overlay">
      <div class="picking-modal-box" style="max-width: 820px; max-height: 92vh;">
        <div class="picking-modal-header">
          <h5 class="mb-0">
            <i class="fas fa-barcode me-2"></i>
            Picking Packing
          </h5>
          <button class="btn btn-link btn-sm p-0 text-secondary" @click="closePickingModal">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="picking-modal-body">
          <p class="text-xs text-secondary mb-3">
            Escanea el código de barras (SKU) de cada producto para marcarlo como preparado.
          </p>

          <div class="picking-scan-input-wrapper">
            <input
              ref="scanInput"
              v-model="scanValue"
              type="text"
              class="form-control picking-scan-input"
              placeholder="Escanear o digitar SKU..."
              @keyup.enter="handleScan"
              @input="onScanInput"
              :disabled="isScanning"
            />
            <button
              class="btn btn-primary picking-scan-btn"
              @click="handleScan"
              :disabled="isScanning || !scanValue.trim()"
            >
              <i class="fas fa-check" v-if="!isScanning"></i>
              <i class="fas fa-spinner fa-spin" v-else></i>
            </button>
            <button
              v-if="isMobileDevice"
              class="btn btn-dark picking-scan-btn"
              title="Escanear con la cámara"
              @click="startCameraScanner"
              :disabled="isScanning"
            >
              <i class="fas fa-camera"></i>
            </button>
          </div>

          <div v-if="scanMessage" class="picking-scan-message" :class="scanMessageType">
            <i :class="scanMessageType === 'success' ? 'fas fa-check-circle' : 'fas fa-exclamation-circle'"></i>
            {{ scanMessage }}
          </div>

          <div class="picking-progress mt-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="text-xs text-secondary font-weight-bold">Progreso</span>
              <span class="text-xs font-weight-bold">{{ pickedCount }} / {{ pickingUnits.length }}</span>
            </div>
            <div class="progress" style="height: 6px;">
              <div
                class="progress-bar bg-success"
                :style="{ width: pickingProgress + '%' }"
              ></div>
            </div>
          </div>

          <div class="picking-items-list mt-3">
            <div
              v-for="unit in sortedPickingUnits"
              :key="unit.key"
              class="picking-item-row"
              :class="{ 'picking-item-picked': unit.picked }"
            >
              <div class="d-flex align-items-center">
                <i
                  :class="unit.picked ? 'fas fa-check-circle text-success' : 'fas fa-clock text-warning'"
                  class="me-2"
                ></i>
                <div>
                  <span class="text-sm font-weight-bold d-block">{{ unit.item.title || '—' }}</span>
                  <span v-if="getVariantTitle(unit.item)" class="text-xs text-secondary d-block">{{ getVariantTitle(unit.item) }}</span>
                  <span class="text-xs text-secondary">SKU: {{ unit.item.sku || '—' }}</span>
                </div>
              </div>
              <div v-if="!isMobileDevice" class="d-flex align-items-center" style="gap: 6px;">
                <button
                  type="button"
                  class="btn btn-outline-success btn-sm mb-0 mx-1"
                  :class="{ 'btn-success': unit.picked }"
                  @click="pickUnit(unit.item)"
                  :disabled="unit.item.toggling || unit.picked"
                  :title="unit.picked ? 'Preparado' : 'Marcar como preparado'"
                >
                  <i :class="unit.item.toggling ? 'fas fa-spinner fa-spin' : 'fas fa-check'"></i>
                </button>
              </div>
            </div>
            <div v-if="!pickingItems.length" class="text-center text-muted text-xs py-3">
              No hay items para picking.
            </div>
          </div>
        </div>

        <div class="picking-modal-footer">
          <button
            v-if="pickingItems.length > 0 && pendingPickingItems.length === 0"
            class="btn btn-success btn-sm w-100"
            @click="completePicking"
            :disabled="isCompletingPicking"
          >
            <i class="fas fa-spinner fa-spin me-1" v-if="isCompletingPicking"></i>
            <i class="fas fa-check me-1" v-else></i> Picking completado
          </button>
          <div v-else class="d-flex align-items-center" :class="isMobileDevice ? 'justify-content-end' : 'justify-content-between'" style="gap: 8px;">
            <button
              v-if="!isMobileDevice"
              class="btn btn-outline-success btn-sm mb-0"
              @click="markAllPicked"
              :disabled="isMarkingAllPicked || pendingPickingItems.length === 0"
              :title="pendingPickingItems.length === 0 ? 'No hay items pendientes' : 'Marcar todos los productos como preparados'"
            >
              <i class="fas fa-spinner fa-spin me-1" v-if="isMarkingAllPicked"></i>
              <i class="fas fa-check-double me-1" v-else></i>
              Marcar todos
            </button>
            <button class="btn btn-outline-secondary btn-sm mb-0" @click="closePickingModal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Shipping -->
    <div v-if="showShippingModal" class="picking-modal-overlay">
      <div class="picking-modal-box" style="max-width: 880px;">
        <div class="picking-modal-header">
          <h5 class="mb-0">
            <i class="fas fa-truck me-2"></i>
            Generar ticket de envío
          </h5>
          <button class="btn btn-link btn-sm p-0 text-secondary" @click="closeShippingModal">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="picking-modal-body">
          <div v-if="shippingError" class="picking-scan-message error mb-3">
            <i class="fas fa-exclamation-circle"></i>
            {{ shippingError }}
          </div>

          <div class="row g-2 mb-3">
            <div class="col-md-6">
              <div class="border rounded p-3 h-100 bg-light">
                <div class="text-xs text-uppercase text-secondary font-weight-bolder mb-3">
                  <i class="fas fa-map-marker-alt me-1"></i> Ubicación del cliente
                </div>
                <div class="text-xs location-info-row"><strong>Nombre:</strong> {{ shippingCustomerName }}</div>
                <div class="text-xs location-info-row"><strong>Dirección:</strong> {{ order?.shipping_address?.address1 || '—' }}</div>
                <div class="text-xs location-info-row"><strong>Ciudad:</strong> {{ order?.shipping_address?.city || '—' }}</div>
                <div class="text-xs location-info-row"><strong>Departamento:</strong> {{ order?.shipping_address?.province || '—' }}</div>
                <div class="text-xs location-info-row"><strong>Código postal:</strong> {{ order?.shipping_address?.zip || '—' }}</div>
                <div class="text-xs location-info-row"><strong>Teléfono:</strong> {{ order?.shipping_address?.phone || '—' }}</div>
                <div class="text-xs location-info-row mb-0"><strong>Email:</strong> {{ order?.email || '—' }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="border rounded p-2 h-100">
                <div class="text-xs text-uppercase text-secondary font-weight-bolder mb-2">
                  <i class="fas fa-calculator me-1"></i> Datos del cálculo de envío
                </div>
                <label class="text-xs text-secondary mb-0">Dirección</label>
                <input v-model="shippingForm.address" class="form-control form-control-sm mb-1" placeholder="Dirección de envío" />
                <div class="row g-1">
                  <div class="col-6">
                    <label class="text-xs text-secondary mb-0">Ciudad</label>
                    <select v-model="shippingForm.city" class="form-select form-select-sm mb-1">
                      <option value="" disabled>Seleccione...</option>
                      <option v-if="cityNotInList" :value="shippingForm.city">{{ shippingForm.city }} (no está en la lista)</option>
                      <option v-for="c in shippingCities" :key="c" :value="c">{{ c }}</option>
                    </select>
                  </div>
                  <div class="col-6">
                    <label class="text-xs text-secondary mb-0">Departamento</label>
                    <select v-model="shippingForm.province" @change="onShippingProvinceChange" class="form-select form-select-sm mb-1">
                      <option value="" disabled>Seleccione...</option>
                      <option v-if="provinceNotInList" :value="shippingForm.province">{{ shippingForm.province }} (no está en la lista)</option>
                      <option v-for="d in shippingDepartments" :key="d" :value="d">{{ d }}</option>
                    </select>
                  </div>
                </div>
                <div class="row g-1">
                  <div class="col-4">
                    <label class="text-xs text-secondary mb-0">Código postal</label>
                    <input v-model="shippingForm.zip" class="form-control form-control-sm mb-1" placeholder="ZIP" />
                  </div>
                  <div class="col-4">
                    <label class="text-xs text-secondary mb-0">Teléfono</label>
                    <input v-model="shippingForm.phone" class="form-control form-control-sm mb-1" placeholder="Teléfono" />
                  </div>
                  <div class="col-4">
                    <label class="text-xs text-secondary mb-0">Cédula/NIT</label>
                    <input v-model="shippingForm.company" class="form-control form-control-sm mb-1" placeholder="Cédula/NIT" />
                  </div>
                </div>
                <div class="row g-1">
                  <div class="col-3">
                    <label class="text-xs text-secondary mb-0">Peso (kg)</label>
                    <input v-model="packageForm.weight" type="number" min="0.01" step="0.01" class="form-control form-control-sm mb-1" />
                  </div>
                  <div class="col-3">
                    <label class="text-xs text-secondary mb-0">Largo (cm)</label>
                    <input v-model="packageForm.length" type="number" min="1" step="1" class="form-control form-control-sm mb-1" />
                  </div>
                  <div class="col-3">
                    <label class="text-xs text-secondary mb-0">Ancho (cm)</label>
                    <input v-model="packageForm.width" type="number" min="1" step="1" class="form-control form-control-sm mb-1" />
                  </div>
                  <div class="col-3">
                    <label class="text-xs text-secondary mb-0">Alto (cm)</label>
                    <input v-model="packageForm.height" type="number" min="1" step="1" class="form-control form-control-sm mb-1" />
                  </div>
                </div>
                <div class="text-xxs text-secondary">
                  Calculado: {{ defaultPackageWeight }} kg (0.3 kg por prenda)
                  <a v-if="isPackageFormModified" href="#" class="ms-1" @click.prevent="initPackageForm">Restablecer</a>
                </div>
                <div v-if="waybillPackage" class="text-xxs mt-1" :class="isPackageFormModified ? 'text-warning' : 'text-success'">
                  <i class="fas me-1" :class="isPackageFormModified ? 'fa-exclamation-triangle' : 'fa-check-circle'"></i>
                  Guía generada con: {{ waybillPackage.weight }} kg ·
                  {{ waybillPackage.length }} × {{ waybillPackage.width }} × {{ waybillPackage.height }} cm
                  <span v-if="isPackageFormModified">(los valores actuales son distintos)</span>
                </div>
                <button
                  class="btn btn-primary btn-sm w-100 mt-2"
                  type="button"
                  @click="recalculateShipping"
                  :disabled="isCalculatingShipping"
                >
                  <i class="fas fa-sync-alt me-1" :class="{ 'fa-spin': isCalculatingShipping }"></i>
                  Recalcular
                </button>
              </div>
            </div>
          </div>

          <div v-if="isCalculatingShipping" class="text-center py-4">
            <i class="fas fa-spinner fa-spin me-1"></i> Calculando opciones de envío...
          </div>

          <div v-else-if="shippingOptions.length">
            <h6 class="text-uppercase text-secondary text-xxs font-weight-bolder mb-2">Opciones de envío</h6>
            <div
              v-for="(opt, idx) in shippingOptions"
              :key="idx"
              class="shipping-option-row"
              :class="{ 'shipping-option-selected': selectedShippingOption === idx }"
              @click="selectedShippingOption = idx"
            >
              <div class="d-flex align-items-center" style="flex:1; min-width:0;">
                <img
                  v-if="opt.carrier_image"
                  :src="opt.carrier_image"
                  :alt="opt.carrier_name"
                  style="width: 32px; height: 32px; object-fit: contain; margin-right: 8px;"
                />
                <i v-else class="fas fa-shipping-fast me-2 text-primary"></i>
                <div style="min-width:0;">
                  <span class="text-sm font-weight-bold d-block">{{ opt.carrier_name || opt.shipping_method || ('Opción ' + (idx + 1)) }}</span>
                  <span class="text-xs text-secondary d-block">
                    {{ opt.delivery_days ? opt.delivery_days + ' día(s)' : (opt.delivery_time || opt.eta || '—') }}
                    <span v-if="opt.shipping_method" class="text-muted">— {{ opt.shipping_method }}</span>
                  </span>
                </div>
              </div>
              <div class="text-end ms-2" style="white-space:nowrap;">
                <span class="text-sm font-weight-bold d-block">{{ formatMoney(opt.price || opt.total || 0, 'COP') }}</span>
                <button class="btn btn-link btn-xs p-0 text-xs" @click.stop="showRawResponse = !showRawResponse">
                  Ver JSON
                </button>
              </div>
            </div>

            <div v-if="showRawResponse" class="mt-2 p-2 bg-light rounded">
              <pre class="text-xs mb-0" style="max-height:200px; overflow:auto;">{{ JSON.stringify(shippingOptions, null, 2) }}</pre>
            </div>

            <div class="mt-3">
              <label class="text-xs text-secondary font-weight-bold">Método de pago</label>
              <select v-model="shippingPaymentMethod" class="form-control form-control-sm mt-1">
                <option value="">Flete pago</option>
                <option value="Contraentrega">Contraentrega + Flete</option>
                <option value="Flete Contraentrega">Flete Contraentrega</option>
              </select>
            </div>

            <div class="d-flex align-items-center mt-2">
              <input type="checkbox" id="chargeShipping" v-model="chargeShippingToCustomer" style="margin-right: 6px;" />
              <label class="text-xs" for="chargeShipping" style="margin-bottom: 0;">Cobrar envío al cliente</label>
            </div>
          </div>

          <div v-else-if="!isCalculatingShipping && hasCalculatedShipping" class="text-center text-muted text-xs py-3">
            No se encontraron opciones de envío.
          </div>
        </div>
        <div class="picking-modal-footer">
          <button
            v-if="shippingOptions.length && selectedShippingOption !== null"
            class="btn btn-success btn-sm w-100"
            @click="generateTicket"
            :disabled="isGeneratingWaybill"
          >
            <i class="fas fa-spinner fa-spin me-1" v-if="isGeneratingWaybill"></i>
            <i class="fas fa-ticket-alt me-1" v-else></i>
            Generar guía de envío
          </button>
          <button v-else class="btn btn-link btn-sm text-secondary w-100" @click="closeShippingModal">
            Cerrar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal editar cliente -->
    <div v-if="showCustomerEditModal" class="picking-modal-overlay" @click.self="closeCustomerEditModal">
      <div class="picking-modal-box" style="max-width: 500px;">
        <div class="picking-modal-header">
          <h5 class="mb-0">
            <i class="fas fa-pencil-alt me-2"></i>
            Editar cliente
          </h5>
          <button class="btn btn-link btn-sm p-0 text-secondary" @click="closeCustomerEditModal">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="picking-modal-body">
          <div class="mb-2">
            <label class="form-label text-xs text-secondary mb-1">Nombre</label>
            <input v-model="customerEditForm.customer_name" type="text" class="form-control form-control-sm" />
          </div>
          <div class="mb-2">
            <label class="form-label text-xs text-secondary mb-1">Email</label>
            <input v-model="customerEditForm.email" type="text" class="form-control form-control-sm" />
          </div>
          <div class="mb-2">
            <label class="form-label text-xs text-secondary mb-1">Teléfono</label>
            <input v-model="customerEditForm.phone" type="text" class="form-control form-control-sm" />
          </div>
        </div>
        <div class="picking-modal-footer">
          <button class="btn btn-secondary btn-sm" @click="closeCustomerEditModal">Cancelar</button>
          <button
            class="btn btn-primary btn-sm"
            @click="saveCustomer"
            :disabled="isSavingCustomer"
          >
            <i v-if="isSavingCustomer" class="fas fa-spinner fa-spin me-1"></i>
            <i v-else class="fas fa-save me-1"></i>
            Guardar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal editar dirección -->
    <div v-if="showAddressEditModal" class="picking-modal-overlay" @click.self="closeAddressEditModal">
      <div class="picking-modal-box" style="max-width: 500px;">
        <div class="picking-modal-header">
          <h5 class="mb-0">
            <i class="fas fa-pencil-alt me-2"></i>
            Editar dirección de envío
          </h5>
          <button class="btn btn-link btn-sm p-0 text-secondary" @click="closeAddressEditModal">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="picking-modal-body">
          <div class="row">
            <div class="col-md-6 mb-2">
              <label class="form-label text-xs text-secondary mb-1">Nombre</label>
              <input v-model="addressEditForm.first_name" type="text" class="form-control form-control-sm" />
            </div>
            <div class="col-md-6 mb-2">
              <label class="form-label text-xs text-secondary mb-1">Apellido</label>
              <input v-model="addressEditForm.last_name" type="text" class="form-control form-control-sm" />
            </div>
          </div>
          <div class="mb-2">
            <label class="form-label text-xs text-secondary mb-1">Dirección</label>
            <input v-model="addressEditForm.address1" type="text" class="form-control form-control-sm" />
          </div>
          <div class="mb-2">
            <label class="form-label text-xs text-secondary mb-1">Dirección 2</label>
            <input v-model="addressEditForm.address2" type="text" class="form-control form-control-sm" />
          </div>
          <div class="row">
            <div class="col-md-6 mb-2">
              <label class="form-label text-xs text-secondary mb-1">Ciudad</label>
              <input v-model="addressEditForm.city" type="text" class="form-control form-control-sm" />
            </div>
            <div class="col-md-6 mb-2">
              <label class="form-label text-xs text-secondary mb-1">Provincia</label>
              <input v-model="addressEditForm.province" type="text" class="form-control form-control-sm" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-2">
              <label class="form-label text-xs text-secondary mb-1">País</label>
              <input v-model="addressEditForm.country" type="text" class="form-control form-control-sm" />
            </div>
            <div class="col-md-6 mb-2">
              <label class="form-label text-xs text-secondary mb-1">Código postal</label>
              <input v-model="addressEditForm.zip" type="text" class="form-control form-control-sm" />
            </div>
          </div>
          <div class="mb-2">
            <label class="form-label text-xs text-secondary mb-1">Teléfono</label>
            <input v-model="addressEditForm.phone" type="text" class="form-control form-control-sm" />
          </div>
        </div>
        <div class="picking-modal-footer">
          <button class="btn btn-secondary btn-sm" @click="closeAddressEditModal">Cancelar</button>
          <button
            class="btn btn-primary btn-sm"
            @click="saveAddress"
            :disabled="isSavingAddress"
          >
            <i v-if="isSavingAddress" class="fas fa-spinner fa-spin me-1"></i>
            <i v-else class="fas fa-save me-1"></i>
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import shopifyService from "@/services/shopify.service";
import shopifyVeService from "@/services/shopifyVenezuela.service";
import userService from "@/services/user.service";
import Swal from "sweetalert2";
import { BrowserMultiFormatReader } from '@zxing/browser';
import { BarcodeFormat, DecodeHintType } from '@zxing/library';
import ciudadesData from "@/data/ciudades.json";

// Índice de búsqueda: nombre normalizado -> codigo_dane
// Normaliza: mayúsculas, sin tildes, sin espacios extra, sin paréntesis/depto.
function normalizeCityName(name) {
  if (!name) return "";
  return String(name)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // quita tildes
    .toUpperCase()
    .trim()
    .replace(/\s+/g, " ");
}

// Nombres oficiales de departamento -> nombre usado en ciudades.json
const DPTO_ALIASES = {
  "VALLE DEL CAUCA": "VALLE",
  "SAN ANDRES": "SAN ANDRES Y PROVIDENCIA",
  "SAN ANDRES, PROVIDENCIA Y SANTA CATALINA": "SAN ANDRES Y PROVIDENCIA",
  "ARCHIPIELAGO DE SAN ANDRES, PROVIDENCIA Y SANTA CATALINA": "SAN ANDRES Y PROVIDENCIA",
};

function normalizeDeptName(name) {
  const norm = normalizeCityName(name);
  return DPTO_ALIASES[norm] || norm;
}

const ciudadIndex = (() => {
  const index = new Map();
  for (const c of ciudadesData) {
    if (!c.activo) continue;
    const entry = { dane: c.codigo_dane, dpto: normalizeDeptName(c.dpto) };
    // Nombre completo sin el sufijo de departamento entre paréntesis
    const baseName = (c.nombre || "").replace(/\s*\([^)]*\)\s*$/, "").trim();
    const keys = new Set(
      [baseName, c.abreviado, c.nombre].map(normalizeCityName).filter(Boolean)
    );
    for (const norm of keys) {
      if (!index.has(norm)) index.set(norm, []);
      index.get(norm).push(entry);
    }
  }
  return index;
})();

// Códigos ISO de provincia de Shopify -> nombre de departamento usado en ciudades.json
const PROVINCE_CODE_TO_DPTO = {
  AMA: "AMAZONAS", ANT: "ANTIOQUIA", ARA: "ARAUCA", ATL: "ATLANTICO",
  BOL: "BOLIVAR", BOY: "BOYACA", CAL: "CALDAS", CAQ: "CAQUETA",
  CAS: "CASANARE", CAU: "CAUCA", CES: "CESAR", CHO: "CHOCO",
  COR: "CORDOBA", CUN: "CUNDINAMARCA", DC: "CUNDINAMARCA",
  GUA: "GUAINIA", GUV: "GUAVIARE", HUI: "HUILA", LAG: "LA GUAJIRA",
  MAG: "MAGDALENA", MET: "META", NAR: "NARINO", NSA: "NORTE DE SANTANDER",
  PUT: "PUTUMAYO", QUI: "QUINDIO", RIS: "RISARALDA", SAN: "SANTANDER",
  SAP: "SAN ANDRES Y PROVIDENCIA", SUC: "SUCRE", TOL: "TOLIMA",
  VAC: "VALLE", VAU: "VAUPES", VID: "VICHADA",
};

// Puntaje de coincidencia provincia (dirección) vs dpto (ciudades.json)
function deptScore(provinceNorm, dptoNorm) {
  if (!provinceNorm || !dptoNorm) return 0;
  if (provinceNorm === dptoNorm) return 3;
  if (provinceNorm.startsWith(dptoNorm) || dptoNorm.startsWith(provinceNorm)) return 2;
  const re = new RegExp(`(^|\\s)${dptoNorm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}(\\s|$)`);
  if (re.test(provinceNorm)) return 1;
  return 0;
}

// De una lista de ciudades candidatas elige la que coincide con el departamento
function pickByProvince(candidates, provinceNorm) {
  if (!candidates || !candidates.length) return "";
  if (candidates.length === 1 || !provinceNorm) return candidates[0].dane;
  let best = candidates[0];
  let bestScore = 0;
  for (const c of candidates) {
    const score = deptScore(provinceNorm, c.dpto);
    if (score > bestScore) {
      best = c;
      bestScore = score;
    }
  }
  return best.dane;
}

function buscarCodigoDane(cityName, provinceName, provinceCode) {
  if (!cityName) return "";
  const norm = normalizeCityName(cityName);
  if (!norm) return "";
  const dept = normalizeDeptName(provinceName) || PROVINCE_CODE_TO_DPTO[(provinceCode || "").toUpperCase()] || "";
  // Búsqueda exacta
  if (ciudadIndex.has(norm)) return pickByProvince(ciudadIndex.get(norm), dept);
  // Búsqueda por prefijo (ej: "BOGOTA D.C." -> "BOGOTA")
  let candidates = [];
  for (const [key, list] of ciudadIndex) {
    if (norm.startsWith(key) || key.startsWith(norm)) candidates.push(...list);
  }
  if (candidates.length) return pickByProvince(candidates, dept);
  // Búsqueda por inclusión de palabra principal
  const firstWord = norm.split(" ")[0];
  if (firstWord) {
    candidates = [];
    for (const [key, list] of ciudadIndex) {
      if (key.split(" ")[0] === firstWord) candidates.push(...list);
    }
    if (candidates.length) return pickByProvince(candidates, dept);
  }
  return "";
}

// Municipios de difícil acceso (códigos DANE de ciudades.json): la guía debe
// generarse con el peso y las medidas reales del paquete.
const REMOTE_SHIPPING_DANE = new Set([
  "19318000", // GUAPI (CAU)
  "19418000", // LOPEZ DE MICAY (CAU)
  "19809000", // TIMBIQUI (CAU)
  "27006003", // CAPURGANA (CHOCO)
  "27075000", // BAHIA SOLANO MUTIS (CHOCO)
  "27372000", // JURADO (CHOCO)
  "27495000", // NUQUI (CHOCO)
  "50350000", // LA MACARENA (META)
  "50370000", // URIBE (META)
  "88001000", // SAN ANDRES ISLA (S/ANDRES)
  "88564000", // PROVIDENCIA (S/ANDRES)
  "88564006", // SANTA CATALINA (S/ANDRES)
  "91001000", // LETICIA (AMAZ)
  "94001000", // INIRIDA (GUAI)
  "97001000", // MITU (V/PES)
  "99001000", // PUERTO CARREÑO (VICH)
  "99524000", // LA PRIMAVERA (VICH)
  "99624000", // SANTA ROSALIA (VICH)
  "99773000", // CUMARIBO (VICH)
]);

export default {
  name: "ShopifyOrderDetail",
  data() {
    return {
      order: null,
      isLoading: false,
      swipeStart: null,
      isNavigating: false,
      isCameraScanning: false,
      scannerReader: null,
      scannerControls: null,
      scannerStream: null,
      scannerFrameId: null,
      torchAvailable: false,
      torchOn: false,
      isMobileDevice: false,
      // Cards desplegables en móvil (cerradas por defecto)
      openCards: { info: false, location: false, shipping: false },
      showPickingModal: false,
      pickingItems: [],
      // Unidades ya escaneadas por registro de picking (id => cantidad)
      pickedUnits: {},
      scanValue: "",
      scanMessage: "",
      scanMessageType: "",
      isScanning: false,
      scanDebounceTimer: null,
      isCompletingPicking: false,
      isMarkingAllPicked: false,
      showShippingModal: false,
      isCalculatingShipping: false,
      hasCalculatedShipping: false,
      shippingOptions: [],
      shippingError: "",
      selectedShippingOption: null,
      shippingPaymentMethod: "",
      chargeShippingToCustomer: true,
      shippingForm: {
        address: "",
        city: "",
        province: "",
        zip: "",
        phone: "",
        company: "",
      },
      shippingFormBaseline: "",
      isSavingShippingForm: false,
      // Peso (kg) y dimensiones (cm) del paquete para cotizar y generar la guía.
      packageForm: { weight: "", length: 1, width: 1, height: 1 },
      localDeliveryForm: { enabled: false, user_id: null, amount: "" },
      localDeliveryBaseline: "",
      localDeliveryUsers: [],
      isSavingLocalDelivery: false,
      isGeneratingWaybill: false,
      isPrintingWaybill: false,
      isMarkingDispatched: false,
      changingShippingStatus: null,
      isSyncingKubapp: false,
      isMarkingInvoiced: false,
      showRawResponse: false,
      showCustomerEditModal: false,
      isSavingCustomer: false,
      customerEditForm: {
        customer_name: "",
        email: "",
        phone: "",
      },
      showAddressEditModal: false,
      isSavingAddress: false,
    };
  },
  computed: {
    shippingCustomerName() {
      const addr = this.order?.shipping_address || {};
      return this.order?.customer_name
        || [addr.first_name, addr.last_name].filter(Boolean).join(' ')
        || '—';
    },
    shippingDepartments() {
      const set = new Set();
      for (const c of ciudadesData) {
        if (c.activo && c.dpto) set.add(c.dpto);
      }
      return [...set].sort((a, b) => a.localeCompare(b, "es"));
    },
    shippingCities() {
      const dept = this.shippingForm.province.trim();
      if (!dept) return [];
      const deptNorm = normalizeDeptName(dept);
      const map = new Map();
      for (const c of ciudadesData) {
        if (!c.activo || normalizeDeptName(c.dpto || "") !== deptNorm) continue;
        const base = (c.nombre || "").replace(/\s*\([^)]*\)\s*$/, "").trim();
        const name = base || (c.abreviado || "").trim();
        if (name) map.set(normalizeCityName(name), name);
      }
      return [...map.values()].sort((a, b) => a.localeCompare(b, "es"));
    },
    isLocalDeliveryDirty() {
      return JSON.stringify(this.localDeliveryForm) !== this.localDeliveryBaseline;
    },
    // 0.3 kg por prenda: suma de las cantidades de todos los productos.
    defaultPackageWeight() {
      const units = this.lineItems.reduce((sum, item) => sum + Math.max(1, parseInt(item.quantity, 10) || 1), 0);
      return Math.round(0.3 * Math.max(1, units) * 100) / 100;
    },
    // Peso y dimensiones con que se generó la guía (null si aún no hay guía).
    waybillPackage() {
      const pkg = this.order?.waybill_package;
      return pkg && typeof pkg === "object" ? pkg : null;
    },
    // Valores de partida del formulario: los de la guía generada o, si no hay, los calculados.
    packageFormBaseline() {
      const pkg = this.waybillPackage;
      if (pkg) {
        return {
          weight: Number(pkg.weight) || this.defaultPackageWeight,
          length: Number(pkg.length) || 1,
          width: Number(pkg.width) || 1,
          height: Number(pkg.height) || 1,
        };
      }
      return { weight: this.defaultPackageWeight, length: 1, width: 1, height: 1 };
    },
    isPackageFormModified() {
      const f = this.packageForm;
      const b = this.packageFormBaseline;
      return Number(f.weight) !== b.weight
        || Number(f.length) !== b.length
        || Number(f.width) !== b.width
        || Number(f.height) !== b.height;
    },
    isShippingFormDirty() {
      return JSON.stringify(this.shippingForm) !== this.shippingFormBaseline;
    },
    provinceNotInList() {
      const v = this.shippingForm.province.trim();
      if (!v) return false;
      return !this.shippingDepartments.some((d) => normalizeDeptName(d) === normalizeDeptName(v));
    },
    cityNotInList() {
      const v = this.shippingForm.city.trim();
      if (!v) return false;
      return !this.shippingCities.some((c) => normalizeCityName(c) === normalizeCityName(v));
    },
    canEditItems() {
      return this.order?.source === 'pos' && !this.order?.shopify_order_id && !this.isVeOrder;
    },
    lineItems() {
      if (!this.order) return [];
      const items = this.order.line_items;
      if (!Array.isArray(items)) return [];
      if (this.isVeOrder) {
        const originRank = (item) => (item?.origin === 'VZL' ? 0 : item?.origin === 'COP' ? 1 : 2);
        return [...items].sort((a, b) => originRank(a) - originRank(b));
      }
      return items;
    },
    hasVenezuelaItems() {
      return this.lineItems.some((item) => item?.origin === 'VZL');
    },
    hasColombiaItems() {
      return this.lineItems.some((item) => item?.origin === 'COP');
    },
    hasKubappSync() {
      return this.order?.kubapp_json != null;
    },
    pendingPickingItems() {
      return this.pickingItems.filter((i) => i.status !== "picked");
    },
    // Una fila por unidad: un producto con cantidad 3 se muestra 3 veces y
    // cada escaneo marca una unidad. El registro se marca como preparado en
    // el backend cuando se completan todas sus unidades.
    pickingUnits() {
      const units = [];
      this.pickingItems.forEach((item) => {
        const total = this.pickingItemQuantity(item);
        const done = item.status === 'picked' ? total : (this.pickedUnits[item.id] || 0);
        for (let index = 0; index < total; index++) {
          units.push({ key: `${item.id}-${index}`, item, index, total, picked: index < done });
        }
      });
      return units;
    },
    sortedPickingUnits() {
      return [...this.pickingUnits].sort((a, b) => Number(a.picked) - Number(b.picked));
    },
    pickedCount() {
      return this.pickingUnits.filter((u) => u.picked).length;
    },
    pickingProgress() {
      if (!this.pickingUnits.length) return 0;
      return Math.round((this.pickedCount / this.pickingUnits.length) * 100);
    },
    currentStatus() {
      if (!this.order) return '';
      const history = Array.isArray(this.order.status_history) ? this.order.status_history : [];
      if (history.length) return history[history.length - 1]?.status || 'NO PREPARADO';
      return this.order.fulfillment_status || 'NO PREPARADO';
    },
    // Cúcuta, Los Patios y Villa del Rosario no llevan guía (misma regla que el
    // botón "Generar ticket de envío"); se toma la ciudad guardada en el pedido.
    isRestrictedShippingCity() {
      return this.isRestrictedCity(this.order?.shipping_address?.city);
    },
    currentStatusBadgeClass() {
      const classes = {
        'ALISTANDO': 'bg-gradient-info',
        'PREPARADO': 'bg-gradient-success',
        'APROBADO ENVIO': 'bg-gradient-warning',
        'GUIA GENERADA': 'bg-gradient-dark',
        'DESPACHADO': 'bg-gradient-primary',
        'ENTREGADO': 'bg-gradient-success',
        'CANCELADO': 'bg-gradient-danger',
      };
      return classes[this.currentStatus] || 'bg-gradient-secondary';
    },
    isOrderPrepared() {
      if (!this.order) return false;
      const history = Array.isArray(this.order.status_history) ? this.order.status_history : [];
      if (history.length) {
        return history[history.length - 1]?.status === 'PREPARADO';
      }
      return this.order.fulfillment_status === 'PREPARADO';
    },
    isOrderDispatched() {
      if (!this.order) return false;
      const history = Array.isArray(this.order.status_history) ? this.order.status_history : [];
      if (history.length) {
        const last = history[history.length - 1]?.status;
        return last === 'DESPACHADO' || last === 'ENTREGADO';
      }
      return this.order.fulfillment_status === 'DESPACHADO' || this.order.fulfillment_status === 'ENTREGADO';
    },
    hasWaybill() {
      return !!this.waybillId;
    },
    isRemoteShippingCity() {
      return this.isRemoteCity(this.order?.shipping_address);
    },
    // Medidas por defecto (1 × 1 × 1 cm): no son las reales del paquete.
    hasDefaultPackageDimensions() {
      const f = this.packageForm;
      return [f.length, f.width, f.height].every((v) => Number(v) === 1);
    },
    // Id de la guía de Conenvios: la generada desde Mistock (picking_json) o,
    // si la guía se creó por fuera, el número de seguimiento de Conenvios que
    // trae el pedido de Shopify en sus fulfillments.
    waybillId() {
      if (!this.order) return null;
      const pj = this.order.picking_json;
      if (pj && typeof pj === 'object' && (pj.id || (pj.data && pj.data.id))) {
        return pj.id || pj.data.id;
      }
      const fulfillments = this.order.shopify_json?.fulfillments || [];
      const tracked = fulfillments.find((f) => f.status !== 'cancelled'
        && f.tracking_number
        && (/conenvios/i.test(f.tracking_company || '') || /conenvios\.com/i.test(f.tracking_url || '')));
      return tracked ? tracked.tracking_number : null;
    },
    isVeOrder() {
      return (
        this.$route.name === 'Shopify Vzla Order Detail' ||
        this.$route.query.source === 'shopify-ve'
      );
    },
    pickingApi() {
      return this.isVeOrder ? shopifyVeService : shopifyService;
    },
  },
  watch: {
    isRestrictedShippingCity(val) {
      if (val && !this.localDeliveryUsers.length) this.fetchLocalDeliveryUsers();
    },
    // Al deslizar a otro pedido se reutiliza el componente: recargar
    "$route.query.id"(newId, oldId) {
      if (newId && newId !== oldId) {
        this.order = null;
        this.pickingItems = [];
        this.pickedUnits = {};
        window.scrollTo(0, 0);
        this.fetchOrder();
      }
    },
  },
  mounted() {
    this.isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || (window.innerWidth <= 1024 && 'ontouchstart' in window);
    this.fetchOrder();
  },
  beforeUnmount() {
    if (this.scanDebounceTimer) {
      clearTimeout(this.scanDebounceTimer);
    }
    this.stopCameraScanner();
  },
  methods: {
    itemPrice(item) {
      if (item == null) return 0;
      if (item.price != null) return parseFloat(item.price) || 0;
      if (item.unit_price != null) return parseFloat(item.unit_price) || 0;
      return 0;
    },
    itemTotal(item) {
      if (item == null) return 0;
      if (item.line_total != null) return parseFloat(item.line_total) || 0;
      if (item.line_subtotal != null) return parseFloat(item.line_subtotal) || 0;
      return this.itemPrice(item) * (parseInt(item.quantity) || 1);
    },
    itemPriceCop(item) {
      const rate = parseFloat(this.order?.usd_exchange_rate);
      if (!rate) return '—';
      return this.formatMoney(this.itemPrice(item) * rate, 'COP');
    },
    formatNumber(value) {
      if (value == null) return '—';
      return new Intl.NumberFormat('es-CO', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(parseFloat(value) || 0);
    },
    formatExcelNumber(value) {
      // Número directo para pegar en Kubapp: sin puntos de miles, 2 decimales (ej: 128084.30)
      const n = parseFloat(value) || 0;
      return n.toFixed(2);
    },
    escapeExcelCell(raw) {
      if (raw == null || raw === '') return '';
      return String(raw).replace(/\t/g, ' ').replace(/\r?\n/g, ' ').trim();
    },
    escapeExcelHtml(raw) {
      return this.escapeExcelCell(raw)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    },
    // Los códigos numéricos (ej: 0155) se pierden el cero inicial al pegar si van
    // como número; con ="0155" Excel y las grillas tipo Excel lo leen como texto.
    excelTextCodeFormula(raw) {
      const s = this.escapeExcelCell(raw);
      return /^[0-9]+$/.test(s) ? `="${s}"` : s;
    },
    async copyVeItemsForExcel() {
      const rows = this.lineItems.filter((item) => item?.origin === 'VZL');
      if (!rows.length) {
        await Swal.fire({
          icon: 'info',
          title: 'Sin ítems VZL',
          text: 'No hay productos de Venezuela en este pedido para copiar.',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      const rate = parseFloat(this.order?.usd_exchange_rate);
      if (!rate) {
        await Swal.fire({
          icon: 'info',
          title: 'Sin tasa de cambio',
          text: 'Este pedido no tiene la tasa USD almacenada; resincronízalo para calcular el precio en pesos.',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      const header = [
        'Producto', 'Descripcion', 'Lote', 'Cantidad', 'Unidad',
        'Precio', 'Descuento', 'Cod IVA', 'Remisión', 'Precio Ref',
      ].join('\t');

      const rowsData = rows.map((item) => {
        const ref = item.codigo_prod || item.sku || '';
        const lote = [item.size_name, item.color_name].filter(Boolean).join(' ')
          || (item.variant_title || '');
        const qty = parseFloat(item.quantity) || 0;
        const priceCop = this.itemPrice(item) * rate;

        return [
          this.escapeExcelCell(ref),
          '',
          this.escapeExcelCell(lote),
          String(qty),
          'UN',
          this.formatExcelNumber(priceCop),
          '',
          '0',
          '',
          '',
        ];
      });

      // Texto plano: códigos numéricos como ="0155" para que la celda se lea como texto.
      const tsv = [header, ...rowsData.map((cells) => cells
        .map((cell, i) => (i === 0 ? this.excelTextCodeFormula(cell) : cell))
        .join('\t'))].join('\n');

      // HTML (protocolo de Excel): la columna Producto va con formato de texto
      // (mso-number-format) para conservar los ceros a la izquierda al pegar.
      const headerLabels = header.split('\t');
      const htmlRows = rowsData.map((cells) => `<tr>${cells
        .map((cell, i) => (i === 0
          ? `<td style="mso-number-format:'\\@';">${this.escapeExcelHtml(cell)}</td>`
          : `<td>${this.escapeExcelHtml(cell)}</td>`))
        .join('')}</tr>`).join('');
      const html = `<table><thead><tr>${headerLabels
        .map((h) => `<th>${h}</th>`).join('')}</tr></thead><tbody>${htmlRows}</tbody></table>`;

      try {
        if (navigator.clipboard?.write && typeof window.ClipboardItem !== 'undefined') {
          await navigator.clipboard.write([new window.ClipboardItem({
            'text/plain': new Blob([tsv], { type: 'text/plain' }),
            'text/html': new Blob([html], { type: 'text/html' }),
          })]);
        } else if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(tsv);
        } else {
          const ta = document.createElement('textarea');
          ta.value = tsv;
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }

        await Swal.fire({
          icon: 'success',
          title: 'Ítems copiados',
          text: `${rows.length} ítem(s) VZL copiados al portapapeles. Crea la factura en Kubapp Venezuela y pega los registros copiados (Ctrl+V).`,
          confirmButtonText: 'Entendido',
        });
      } catch (e) {
        await Swal.fire({
          icon: 'error',
          title: 'No se pudo copiar',
          text: 'El navegador bloqueó el portapapeles o no hay permisos HTTPS.',
          confirmButtonText: 'Aceptar',
        });
      }
    },
    async syncOrderToKubapp() {
      if (!this.order?.id || this.isSyncingKubapp) return;

      const confirm = await Swal.fire({
        icon: 'question',
        title: 'Sincronizar con Kubapp Colombia',
        text: 'Se enviará la factura de venta de este pedido directamente a Kubapp Colombia. ¿Continuar?',
        showCancelButton: true,
        confirmButtonText: 'Sincronizar',
        cancelButtonText: 'Cancelar',
      });
      if (!confirm.isConfirmed) return;

      this.isSyncingKubapp = true;
      try {
        const response = await shopifyVeService.syncOrderToKubapp(this.order.id);
        const data = response?.data || {};

        if (!data.success) {
          throw new Error(data.message || 'No se pudo sincronizar con Kubapp.');
        }

        if (data.order && this.order) {
          this.order.kubapp_invoiced_at = data.order.kubapp_invoiced_at;
          this.order.kubapp_json = data.order.kubapp_json ?? [];
        }

        await Swal.fire({
          icon: 'success',
          title: 'Factura sincronizada',
          text: data.message || 'La factura de venta fue registrada en Kubapp.',
          confirmButtonText: 'Aceptar',
        });
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Error al sincronizar',
          text: error?.response?.data?.message || error.message || 'No se pudo sincronizar con Kubapp.',
          confirmButtonText: 'Aceptar',
        });
      } finally {
        this.isSyncingKubapp = false;
      }
    },
    async toggleInvoiced() {
      if (!this.order?.id || this.isMarkingInvoiced) return;

      const isInvoiced = !!this.order.kubapp_invoiced_at;
      const confirm = await Swal.fire({
        icon: 'question',
        title: isInvoiced ? 'Quitar marca de facturado' : 'Marcar como facturado',
        text: isInvoiced
          ? 'Se quitará la marca de facturación de este pedido. ¿Continuar?'
          : 'Se marcará este pedido como facturado. ¿Continuar?',
        showCancelButton: true,
        confirmButtonText: isInvoiced ? 'Quitar marca' : 'Marcar',
        cancelButtonText: 'Cancelar',
      });
      if (!confirm.isConfirmed) return;

      this.isMarkingInvoiced = true;
      try {
        const response = await shopifyVeService.markOrderInvoiced(this.order.id, !isInvoiced);
        const data = response?.data || {};

        if (!data.success) {
          throw new Error(data.message || 'No se pudo actualizar la orden.');
        }

        if (data.order) {
          this.order.kubapp_invoiced_at = data.order.kubapp_invoiced_at;
        }
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || error.message || 'No se pudo actualizar la orden.',
          confirmButtonText: 'Aceptar',
        });
      } finally {
        this.isMarkingInvoiced = false;
      }
    },
    orderLabel(order) {
      if (order?.source === "shopify" || order?.source === "shopify-ve") {
        return order.name || `#${order.shopify_order_id}`;
      }
      return `#${order.id}`;
    },
    onScanInput() {
      if (this.scanDebounceTimer) {
        clearTimeout(this.scanDebounceTimer);
      }
      const val = this.scanValue.trim();
      if (!val) return;
      this.scanDebounceTimer = setTimeout(() => {
        this.handleScan();
      }, 300);
    },
    isCardOpen(card) {
      return !this.isMobileDevice || this.openCards[card];
    },
    toggleCard(card) {
      if (!this.isMobileDevice) return;
      this.openCards[card] = !this.openCards[card];
    },
    onSwipeStart(e) {
      this.swipeStart = null;
      if (e.touches.length !== 1) return;
      // No navegar si el gesto empieza en una tabla con scroll horizontal o en un input
      if (e.target.closest('.table-responsive, input, textarea, select')) return;
      const t = e.touches[0];
      this.swipeStart = { x: t.clientX, y: t.clientY, time: Date.now() };
    },
    onSwipeEnd(e) {
      const start = this.swipeStart;
      this.swipeStart = null;
      if (!start || this.isLoading || this.isNavigating) return;
      if (this.showPickingModal || this.showShippingModal
        || this.showCustomerEditModal || this.showAddressEditModal) return;

      const t = e.changedTouches[0];
      const dx = t.clientX - start.x;
      const dy = t.clientY - start.y;
      const elapsed = Date.now() - start.time;
      // Gesto horizontal claro y rápido, para no confundirlo con el scroll
      if (Math.abs(dx) < 80 || Math.abs(dx) < Math.abs(dy) * 2 || elapsed > 800) return;

      // Deslizar a la izquierda = siguiente; a la derecha = anterior
      this.goToAdjacentOrder(dx < 0 ? 1 : -1);
    },
    async goToAdjacentOrder(step) {
      let nav = [];
      try {
        nav = JSON.parse(sessionStorage.getItem('shopifyOrdersNav') || '[]');
      } catch (e) {
        nav = [];
      }
      const source = this.$route.query.source || 'shopify';
      const id = String(this.$route.query.id);
      const findIndex = (list) => list.findIndex((o) => String(o.id) === id && (o.source || 'shopify') === source);
      let index = findIndex(nav);
      let target = index === -1 ? null : nav[index + step];
      // Al abrir un pedido desde la búsqueda (p. ej. escaneando el código de
      // barras) la lista guardada solo tiene ese pedido: se reconstruye sin la
      // búsqueda para poder pasar a los pedidos vecinos.
      if (!target && !this.isVeOrder && this.$route.query.id) {
        this.isNavigating = true;
        try {
          nav = await this.buildOrdersNavAround(source, id);
        } finally {
          this.isNavigating = false;
        }
        index = findIndex(nav);
        target = index === -1 ? null : nav[index + step];
      }
      if (!target) {
        Swal.fire({
          toast: true,
          position: 'top',
          icon: 'info',
          title: step > 0 ? 'No hay pedido siguiente' : 'No hay pedido anterior',
          timer: 1500,
          showConfirmButton: false,
        });
        return;
      }
      this.$router.replace({
        name: this.$route.name,
        query: { ...this.$route.query, source: target.source, id: target.id },
      });
    },
    // Recorre la lista de pedidos (filtros del listado sin la búsqueda; si no
    // aparece, sin filtros) hasta encontrar el pedido actual y guarda esa
    // lista, con el pedido siguiente incluido, como navegación del deslizamiento.
    async buildOrdersNavAround(source, id) {
      let saved = {};
      try {
        saved = JSON.parse(sessionStorage.getItem('shopifyOrders.filters') || '{}') || {};
      } catch (e) {
        saved = {};
      }
      const filtered = {
        status: saved.statusFilter,
        payment_status: saved.paymentStatusFilter,
        cod_filter: saved.codFilter,
        payment_method: saved.paymentMethodFilter,
        printed_filter: saved.printedFilter,
        department: saved.departmentFilter,
        city: (saved.cityFilter || '').trim(),
        date_from: saved.dateFromFilter,
        date_to: saved.dateToFilter,
      };
      const attempts = Object.values(filtered).some((v) => v) ? [filtered, {}] : [{}];
      const maxPages = 10;
      const isCurrent = (o) => String(o.id) === id && (o.source || 'shopify') === source;

      for (const filters of attempts) {
        const nav = [];
        let found = -1;
        for (let page = 1; page <= maxPages; page++) {
          let orders = [];
          try {
            const response = await shopifyService.getOrders({ ...filters, page, per_page: 50 });
            orders = response?.data?.data || [];
          } catch (e) {
            return [];
          }
          nav.push(...orders.map((o) => ({ source: o.source || 'shopify', id: o.id })));
          if (found === -1) found = nav.findIndex(isCurrent);
          // Se carga una página más si el pedido quedó al final, para tener el siguiente
          if (!orders.length || (found !== -1 && found < nav.length - 1)) break;
        }
        if (found !== -1) {
          try {
            sessionStorage.setItem('shopifyOrdersNav', JSON.stringify(nav));
          } catch (e) {
            // sessionStorage no disponible: solo se usa para esta navegación
          }
          return nav;
        }
      }
      return [];
    },
    async fetchOrder() {
      const source = this.$route.query.source || 'shopify';
      const id = this.$route.query.id;
      if (!id) {
        this.order = null;
        return;
      }
      this.isLoading = true;
      try {
        const response = await shopifyService.getOrder(source, id);
        this.order = response?.data?.data ?? null;
        if (this.order) {
          this.initShippingForm();
          this.initPackageForm();
          this.initLocalDeliveryForm();
          await this.fetchPicking(this.order.id);
          this.warnRemoteShippingCity();
        }
      } catch (error) {
        console.error("Error al cargar el pedido:", error);
        this.order = null;
      } finally {
        this.isLoading = false;
      }
    },
    // Pedido listo para guía hacia un municipio de difícil acceso: avisar que
    // se deben colocar el peso y las medidas reales antes de generarla.
    warnRemoteShippingCity() {
      if (this.isVeOrder || this.currentStatus !== 'PREPARADO' || this.hasWaybill
        || this.isRestrictedShippingCity || !this.isRemoteShippingCity) return;
      this.showRemoteShippingAlert(this.order.shipping_address);
    },
    // Antes de cotizar, aprobar o generar la guía: si el destino es de difícil
    // acceso y las medidas siguen en 1 × 1 × 1, se repite la alerta y se detiene.
    async blockDefaultPackageDimensions(addr) {
      if (!this.hasDefaultPackageDimensions || !this.isRemoteCity(addr)) return false;
      await this.showRemoteShippingAlert(addr);
      return true;
    },
    isRemoteCity(addr) {
      if (!addr) return false;
      const dane = buscarCodigoDane(addr.city, addr.province, addr.province_code);
      return REMOTE_SHIPPING_DANE.has(dane);
    },
    showRemoteShippingAlert(addr) {
      return Swal.fire({
        icon: 'warning',
        title: 'Peso y medidas reales',
        html: `El envío es a <b>${addr?.city || '—'}</b> (${addr?.province || '—'}).<br>`
          + 'Para este municipio debes colocar el <b>peso real</b> y las <b>medidas reales</b> '
          + 'del paquete de este pedido antes de generar la guía.',
        confirmButtonText: 'Entendido',
      });
    },
    async fetchPicking(orderId) {
      try {
        const response = await this.pickingApi.getPicking(orderId);
        this.pickingItems = response?.data?.data ?? [];
        if (!this.pickingItems.length) {
          const initResponse = await this.pickingApi.initPicking(orderId);
          this.pickingItems = initResponse?.data?.data ?? [];
        }
      } catch {
        this.pickingItems = [];
      }
    },
    async startPicking() {
      if (!this.order) return;
      try {
        const response = await this.pickingApi.initPicking(this.order.id);
        this.pickingItems = response?.data?.data ?? [];
      } catch (error) {
        console.error("Error al iniciar picking:", error);
      }
      this.showPickingModal = true;
      this.scanMessage = "";
      this.scanMessageType = "";
      this.$nextTick(() => {
        this.focusScanInput();
      });
    },
    focusScanInput() {
      if (this.$refs.scanInput) {
        this.$refs.scanInput.focus();
      }
    },
    async handleScan() {
      const sku = this.scanValue.trim();
      if (!sku || this.isScanning) return;

      this.isScanning = true;
      this.scanMessage = "";

      try {
        // Si el SKU corresponde a un producto pendiente se marca una unidad;
        // el backend solo se actualiza al completar todas sus unidades.
        const needle = sku.toLowerCase();
        const local = this.pickingItems.find((i) => i.status !== "picked" && !i.toggling
          && [i.sku, i.barcode].some((code) => code && String(code).trim().toLowerCase() === needle));
        if (local) {
          const ok = await this.pickUnit(local);
          const total = this.pickingItemQuantity(local);
          const done = this.pickingItems.find((i) => i.id === local.id)?.status === "picked"
            ? total
            : (this.pickedUnits[local.id] || 0);
          this.scanMessage = !ok
            ? "Error al marcar el producto como preparado."
            : total > 1
              ? `Unidad ${done} de ${total} preparada.`
              : "Producto marcado como preparado.";
          this.scanMessageType = ok ? "success" : "error";
          return;
        }

        const response = await this.pickingApi.scanPicking(this.order.id, sku);
        const data = response?.data;

        if (data?.success) {
          this.scanMessage = data.message || "Producto marcado como preparado.";
          this.scanMessageType = "success";

          const updated = data.data;
          if (updated) {
            const idx = this.pickingItems.findIndex((i) => i.id === updated.id);
            if (idx >= 0) {
              this.pickingItems[idx] = updated;
            }
          }
        } else {
          this.scanMessage = data?.message || "Error al procesar el SKU.";
          this.scanMessageType = "error";
        }
      } catch (error) {
        const msg = error?.response?.data?.message;
        this.scanMessage = msg || "SKU no encontrado o ya preparado.";
        this.scanMessageType = "error";
      } finally {
        this.isScanning = false;
        this.scanValue = "";
        this.$nextTick(() => {
          this.focusScanInput();
        });
      }
    },
    // Escáner con la cámara (mismo enfoque que en el listado de pedidos):
    // detector nativo si existe, si no ZXing. Cada lectura se envía como SKU.
    startCameraScanner() {
      this.isCameraScanning = true;
      this.torchOn = false;
      this.torchAvailable = false;
      this.$nextTick(async () => {
        try {
          const videoElement = this.$refs.scannerVideo;
          if (!videoElement) return;

          const constraints = {
            audio: false,
            video: {
              facingMode: { ideal: 'environment' },
              width: { ideal: 1920 },
              height: { ideal: 1080 },
              advanced: [{ focusMode: 'continuous' }],
            },
          };

          if (await this.canUseNativeBarcodeDetector()) {
            await this.startNativeScanner(videoElement, constraints);
          } else {
            await this.startZxingScanner(videoElement, constraints);
          }
          this.detectTorchSupport(videoElement);
        } catch (error) {
          console.error('Error al iniciar el escáner:', error);
          Swal.fire('Error', 'No se pudo acceder a la cámara.', 'error');
          this.stopCameraScanner();
        }
      });
    },
    handleCameraScanResult(rawValue) {
      const scannedValue = String(rawValue || '').trim();
      if (!this.isCameraScanning || !scannedValue) return;
      this.stopCameraScanner();
      this.scanValue = scannedValue;
      this.handleScan();
    },
    async canUseNativeBarcodeDetector() {
      if (!('BarcodeDetector' in window)) return false;
      try {
        const supported = await window.BarcodeDetector.getSupportedFormats();
        return supported.includes('code_128');
      } catch (e) {
        return false;
      }
    },
    async startNativeScanner(videoElement, constraints) {
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      this.scannerStream = stream;
      videoElement.srcObject = stream;
      await videoElement.play();

      const supported = await window.BarcodeDetector.getSupportedFormats();
      const formats = ['code_128', 'code_39', 'ean_13', 'ean_8', 'upc_a', 'itf']
        .filter((f) => supported.includes(f));
      const detector = new window.BarcodeDetector({ formats });

      const loop = async () => {
        if (!this.isCameraScanning || this.scannerStream !== stream) return;
        try {
          if (videoElement.readyState >= 2) {
            const codes = await detector.detect(videoElement);
            if (codes.length) {
              this.handleCameraScanResult(codes[0].rawValue);
              return;
            }
          }
        } catch (e) {
          // frame no disponible; se reintenta en el siguiente
        }
        this.scannerFrameId = requestAnimationFrame(loop);
      };
      this.scannerFrameId = requestAnimationFrame(loop);
    },
    async startZxingScanner(videoElement, constraints) {
      const hints = new Map();
      hints.set(DecodeHintType.POSSIBLE_FORMATS, [
        BarcodeFormat.CODE_128,
        BarcodeFormat.CODE_39,
        BarcodeFormat.EAN_13,
        BarcodeFormat.EAN_8,
        BarcodeFormat.UPC_A,
        BarcodeFormat.ITF,
      ]);
      hints.set(DecodeHintType.TRY_HARDER, true);

      this.scannerReader = new BrowserMultiFormatReader(hints, {
        delayBetweenScanAttempts: 80,
      });

      this.scannerControls = await this.scannerReader.decodeFromConstraints(
        constraints,
        videoElement,
        (result) => {
          if (result) this.handleCameraScanResult(result.getText());
        }
      );
    },
    detectTorchSupport(videoElement) {
      const stream = this.scannerStream || videoElement.srcObject;
      const track = stream && stream.getVideoTracks ? stream.getVideoTracks()[0] : null;
      const caps = track && track.getCapabilities ? track.getCapabilities() : {};
      this.torchAvailable = !!caps.torch;
    },
    async toggleTorch() {
      const videoElement = this.$refs.scannerVideo;
      const stream = this.scannerStream || (videoElement && videoElement.srcObject);
      const track = stream ? stream.getVideoTracks()[0] : null;
      if (!track) return;
      try {
        await track.applyConstraints({ advanced: [{ torch: !this.torchOn }] });
        this.torchOn = !this.torchOn;
      } catch (e) {
        console.error('No se pudo cambiar la linterna:', e);
      }
    },
    stopCameraScanner() {
      if (this.scannerFrameId) {
        cancelAnimationFrame(this.scannerFrameId);
        this.scannerFrameId = null;
      }
      if (this.scannerStream) {
        this.scannerStream.getTracks().forEach((t) => t.stop());
        this.scannerStream = null;
      }
      if (this.scannerControls) {
        this.scannerControls.stop();
        this.scannerControls = null;
      }
      this.scannerReader = null;
      this.torchOn = false;
      this.torchAvailable = false;
      this.isCameraScanning = false;
    },
    async completePicking() {
      if (!this.order) return;
      this.isCompletingPicking = true;
      let completed = false;
      try {
        const response = this.isVeOrder
          ? await shopifyVeService.updateOrderStatus(this.order.id, 'PREPARADO')
          : await shopifyService.updateOrderStatus(this.order.source || 'shopify', this.order.id, 'PREPARADO');
        const data = response?.data;
        if (data?.status_history) {
          this.order.status_history = data.status_history;
        }
        if (data?.order?.fulfillment_status) {
          this.order.fulfillment_status = data.order.fulfillment_status;
        }
        completed = true;
      } catch (error) {
        console.error('Error al actualizar estado de la orden:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo actualizar el estado del pedido.',
        });
      } finally {
        this.isCompletingPicking = false;
        this.closePickingModal();
      }

      if (!completed) return;

      // Al completar el picking se abre directamente "Generar ticket de envío"
      // (mismas condiciones que el botón del encabezado).
      const canGenerateTicket = !this.isVeOrder && !this.hasWaybill;
      Swal.fire({
        icon: 'success',
        title: 'Estado actualizado',
        text: 'El estado del pedido cambió a PREPARADO.',
        timer: 2500,
        showConfirmButton: false,
        ...(canGenerateTicket ? { toast: true, position: 'top-end' } : {}),
      });
      if (canGenerateTicket) {
        await this.openShippingModal();
      }
    },
    async markAsDispatched() {
      if (!this.order) return;
      const result = await Swal.fire({
        icon: 'question',
        title: '¿Marcar como despachado?',
        text: 'El pedido se marcará directamente como DESPACHADO sin generar guía de envío.',
        showCancelButton: true,
        confirmButtonText: 'Sí, despachar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#f59e0b',
      });
      if (!result.isConfirmed) return;
      this.isMarkingDispatched = true;
      try {
        const response = this.isVeOrder
          ? await shopifyVeService.updateOrderStatus(this.order.id, 'DESPACHADO')
          : await shopifyService.updateOrderStatus(
              this.order.source || 'shopify',
              this.order.id,
              'DESPACHADO'
            );
        const data = response?.data;
        if (data?.status_history) {
          this.order.status_history = data.status_history;
        }
        if (data?.order?.fulfillment_status) {
          this.order.fulfillment_status = data.order.fulfillment_status;
        }
        Swal.fire({
          icon: 'success',
          title: 'Despachado',
          text: 'El pedido se marcó como DESPACHADO correctamente.',
          timer: 2500,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error('Error al marcar como despachado:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudo actualizar el estado del pedido.',
        });
      } finally {
        this.isMarkingDispatched = false;
      }
    },
    async changeShippingStatus(status) {
      if (!this.order || this.changingShippingStatus) return;
      if (status === 'APROBADO ENVIO'
        && await this.blockDefaultPackageDimensions(this.order.shipping_address)) return;
      const texts = {
        'APROBADO ENVIO': 'El pedido quedará aprobado para que la aplicación de guías genere el ticket de envío.',
        'DESPACHADO': 'El pedido se marcará como DESPACHADO.',
        'ENTREGADO': 'El pedido se marcará como ENTREGADO.',
      };
      const result = await Swal.fire({
        icon: 'question',
        title: `¿Cambiar a ${status}?`,
        text: texts[status],
        showCancelButton: true,
        confirmButtonText: 'Sí, cambiar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      this.changingShippingStatus = status;
      try {
        const response = await shopifyService.updateShippingStatus(this.order.id, status);
        const data = response?.data || {};
        if (data.status_history) {
          this.order.status_history = data.status_history;
        }
        if (data.order?.fulfillment_status) {
          this.order.fulfillment_status = data.order.fulfillment_status;
        }
        Swal.fire({
          icon: 'success',
          title: 'Estado actualizado',
          text: data.dry_run
            ? `El pedido cambió a ${status} (modo simulación: no se actualizó Shopify).`
            : `El pedido cambió a ${status}.`,
          timer: 2500,
          showConfirmButton: false,
        });
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'No se pudo cambiar el estado',
          text: error?.response?.data?.message || 'Error al actualizar el estado del pedido.',
        });
      } finally {
        this.changingShippingStatus = null;
      }
    },
    pickingItemQuantity(item) {
      return Math.max(1, parseInt(item?.quantity) || 1);
    },
    // Marca una unidad del producto; al llegar a la cantidad total se marca
    // el registro como preparado en el backend. Devuelve false si falla.
    async pickUnit(item) {
      if (item.toggling || item.status === "picked") return false;
      const done = (this.pickedUnits[item.id] || 0) + 1;
      if (done < this.pickingItemQuantity(item)) {
        this.pickedUnits = { ...this.pickedUnits, [item.id]: done };
        return true;
      }
      return this.togglePickingItem(item);
    },
    async togglePickingItem(item) {
      if (item.toggling) return false;
      const idx = this.pickingItems.findIndex((i) => i.id === item.id);
      if (idx < 0) return false;
      this.pickingItems[idx].toggling = true;
      try {
        const response = await this.pickingApi.togglePickingItem(item.id);
        const updated = response?.data?.data;
        if (updated) {
          this.pickingItems[idx] = { ...this.pickingItems[idx], ...updated, toggling: false };
          return true;
        }
        this.pickingItems[idx].toggling = false;
        return false;
      } catch (error) {
        console.error('Error al toggle picking item:', error);
        this.pickingItems[idx].toggling = false;
        return false;
      }
    },
    async markAllPicked() {
      if (this.isMarkingAllPicked) return;
      const pending = this.pickingItems.filter((i) => i.status !== "picked" && !i.toggling);
      if (!pending.length) return;
      this.isMarkingAllPicked = true;
      try {
        for (const item of pending) {
          const idx = this.pickingItems.findIndex((i) => i.id === item.id);
          if (idx < 0) continue;
          this.pickingItems[idx].toggling = true;
          try {
            const response = await this.pickingApi.togglePickingItem(item.id);
            const updated = response?.data?.data;
            if (updated) {
              this.pickingItems[idx] = { ...this.pickingItems[idx], ...updated, toggling: false };
            } else {
              this.pickingItems[idx].toggling = false;
            }
          } catch (error) {
            console.error('Error al marcar item como preparado:', error);
            this.pickingItems[idx].toggling = false;
          }
        }
      } finally {
        this.isMarkingAllPicked = false;
      }
    },
    closePickingModal() {
      this.stopCameraScanner();
      this.showPickingModal = false;
      this.scanValue = "";
      this.scanMessage = "";
      this.scanMessageType = "";
    },
    getVariantTitle(pickingItem) {
      const match = this.lineItems.find((li) => {
        if (pickingItem.line_item_id && li.id) {
          return parseInt(li.id) === parseInt(pickingItem.line_item_id);
        }
        if (pickingItem.variant_id && li.variant_id) {
          return parseInt(li.variant_id) === parseInt(pickingItem.variant_id);
        }
        return false;
      });
      return match?.variant_title || '';
    },
    getItemPickingStatus(item) {
      const match = this.pickingItems.find((p) => {
        if (item.id && p.line_item_id) {
          return parseInt(p.line_item_id) === parseInt(item.id);
        }
        if (item.variant_id && p.variant_id) {
          return parseInt(p.variant_id) === parseInt(item.variant_id);
        }
        if (item.sku && p.sku) {
          return p.sku === item.sku;
        }
        return false;
      });
      return match ? match.status : "pending";
    },
    goBack() {
      this.$router.push({ name: "Shopify Ordenes" });
    },
    isRestrictedCity(cityName) {
      if (!cityName) return false;
      const norm = String(cityName)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase()
        .trim()
        .replace(/\s+/g, " ");
      const restricted = [
        "CUCUTA",
        "LOS PATIOS",
        "PATIOS",
        "VILLA DEL ROSARIO",
        "VILLA ROSARIO",
      ];
      return restricted.some((r) => norm === r || norm.includes(r));
    },
    initShippingForm() {
      const addr = this.order?.shipping_address || {};
      this.shippingForm = {
        address: (addr.address1 || "").trim(),
        city: (addr.city || "").trim(),
        province: (addr.province || addr.province_code || "").trim(),
        zip: (addr.zip || "").toString().trim(),
        phone: (addr.phone || "").toString().trim(),
        company: (addr.company || "").toString().trim(),
      };

      // Canonicalizar departamento y ciudad contra ciudades.json para preseleccionar los selects
      const deptMatch = this.shippingDepartments.find(
        (d) => normalizeDeptName(d) === normalizeDeptName(this.shippingForm.province)
      );
      if (deptMatch) {
        this.shippingForm.province = deptMatch;
        const cityMatch = this.shippingCities.find(
          (c) => normalizeCityName(c) === normalizeCityName(this.shippingForm.city)
        );
        if (cityMatch) {
          this.shippingForm.city = cityMatch;
        }
      }
      this.shippingFormBaseline = JSON.stringify(this.shippingForm);
    },
    initPackageForm() {
      this.packageForm = { ...this.packageFormBaseline };
    },
    async saveShippingForm() {
      if (!this.order || this.isSavingShippingForm) return;
      this.isSavingShippingForm = true;
      try {
        const response = await shopifyService.updateShippingAddress(this.order.id, {
          address1: this.shippingForm.address.trim(),
          city: this.shippingForm.city.trim(),
          province: this.shippingForm.province.trim(),
          zip: this.shippingForm.zip.trim(),
          phone: this.shippingForm.phone.trim(),
          company: this.shippingForm.company.trim(),
        });
        const updated = response?.data?.data;
        if (updated) {
          this.order = { ...this.order, shipping_address: updated };
        }
        this.initShippingForm();
        Swal.fire({
          icon: 'success',
          title: 'Datos de envío actualizados',
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error('Error al guardar datos de envío:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudieron guardar los datos de envío.',
        });
      } finally {
        this.isSavingShippingForm = false;
      }
    },
    initLocalDeliveryForm() {
      const userId = this.order?.local_delivery_user_id ?? null;
      const amount = this.order?.local_delivery_amount;
      this.localDeliveryForm = {
        enabled: userId != null,
        user_id: userId,
        amount: amount != null ? String(Number(amount)) : "",
      };
      this.localDeliveryBaseline = JSON.stringify(this.localDeliveryForm);
      if (this.isRestrictedShippingCity && !this.localDeliveryUsers.length) {
        this.fetchLocalDeliveryUsers();
      }
    },
    async fetchLocalDeliveryUsers() {
      try {
        const response = await userService.getAll('all');
        const users = Array.isArray(response?.data) ? response.data : [];
        // Solo domiciliarios; se conserva el ya asignado para no perderlo en el select
        const assignedId = this.order?.local_delivery_user_id ?? null;
        this.localDeliveryUsers = users.filter(u => u.is_domiciliario || u.id === assignedId);
      } catch (error) {
        console.error('Error al cargar usuarios:', error);
      }
    },
    async saveLocalDelivery() {
      if (!this.order || this.isSavingLocalDelivery) return;
      const { enabled, user_id, amount } = this.localDeliveryForm;
      this.isSavingLocalDelivery = true;
      try {
        const response = await shopifyService.updateLocalDelivery(this.order.id, {
          local_delivery_user_id: enabled ? user_id : null,
          local_delivery_amount: enabled && amount !== "" ? Number(amount) : null,
        });
        const updated = response?.data?.data || {};
        this.order = { ...this.order, ...updated };
        this.initLocalDeliveryForm();
        Swal.fire({
          icon: 'success',
          title: 'Envío local actualizado',
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error('Error al guardar envío local:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudo guardar el envío local.',
        });
      } finally {
        this.isSavingLocalDelivery = false;
      }
    },
    onShippingProvinceChange() {
      const city = this.shippingForm.city.trim();
      if (city && this.shippingCities.length
        && !this.shippingCities.some((c) => normalizeCityName(c) === normalizeCityName(city))) {
        this.shippingForm.city = "";
      }
    },
    shippingFormAddress() {
      const original = this.order?.shipping_address || {};
      return {
        ...original,
        address1: this.shippingForm.address.trim(),
        city: this.shippingForm.city.trim(),
        province: this.shippingForm.province.trim(),
        zip: this.shippingForm.zip.trim(),
        phone: this.shippingForm.phone.trim(),
        company: this.shippingForm.company.trim(),
      };
    },
    async recalculateShipping() {
      if (!this.shippingForm.address.trim() || !this.shippingForm.city.trim()) {
        await Swal.fire({
          icon: "warning",
          title: "Datos incompletos",
          text: "Ingresa al menos la dirección y la ciudad para recalcular el envío.",
          confirmButtonText: "Entendido",
        });
        return;
      }
      if (!(await this.validateShippingLocation())) return;
      this.shippingOptions = [];
      this.selectedShippingOption = null;
      this.hasCalculatedShipping = false;
      await this.calculateShipping();
    },
    // Ciudad/departamento deben existir en ciudades.json (Conenvios); si no,
    // el código DANE sale mal y la guía falla.
    async validateShippingLocation() {
      const missing = [];
      if (!this.shippingForm.province.trim() || this.provinceNotInList) {
        missing.push(`Departamento: <b>${this.shippingForm.province.trim() || '—'}</b>`);
      }
      if (!this.shippingForm.city.trim() || this.cityNotInList) {
        missing.push(`Ciudad: <b>${this.shippingForm.city.trim() || '—'}</b>`);
      }
      if (!missing.length) return true;
      await Swal.fire({
        icon: "error",
        title: "Ubicación no encontrada",
        html: `La ubicación no fue encontrada en Conenvios.<br>${missing.join('<br>')}<br><br>`
          + `Selecciona una ciudad y un departamento de la lista antes de cotizar.`,
        confirmButtonText: "Entendido",
      });
      return false;
    },
    async openShippingModal() {
      const city = this.shippingForm.city.trim();
      if (this.isRestrictedCity(city)) {
        await Swal.fire({
          icon: "warning",
          title: "Envío no permitido",
          html: `Este pedido es de <b>${city}</b>.<br>No se permite generar guía de envío para Cúcuta, Los Patios o Villa del Rosario.`,
          confirmButtonText: "Entendido",
        });
        return;
      }
      if (!(await this.validateShippingLocation())) return;
      if (await this.blockDefaultPackageDimensions(this.shippingFormAddress())) return;
      this.showShippingModal = true;
      this.shippingOptions = [];
      this.shippingError = "";
      this.selectedShippingOption = null;
      this.hasCalculatedShipping = false;
      await this.calculateShipping();
    },
    closeShippingModal() {
      this.showShippingModal = false;
      this.shippingOptions = [];
      this.shippingError = "";
      this.selectedShippingOption = null;
      this.hasCalculatedShipping = false;
    },
    buildPackageDetail() {
      const items = this.lineItems;
      const description = items.map((item) => item.title || item.name || "producto").join(", ");
      const totalPrice = items.reduce((sum, item) => sum + this.itemTotal(item), 0);
      // Valores editables del formulario; si alguno queda vacío o inválido se usa el calculado.
      const positive = (value, fallback) => {
        const n = parseFloat(value);
        return Number.isFinite(n) && n > 0 ? n : fallback;
      };
      const weight = positive(this.packageForm.weight, this.defaultPackageWeight);
      return [
        {
          type: "Box",
          package_number: "",
          description: description || "producto",
          weight,
          quantity: 1,
          price: totalPrice,
          dimensions: {
            length: positive(this.packageForm.length, 1),
            width: positive(this.packageForm.width, 1),
            height: positive(this.packageForm.height, 1),
          },
        },
      ];
    },
    getRecipientCity(addrOverride = null) {
      const addr = addrOverride || this.order?.shipping_address;
      if (!addr) return "";
      const city = (addr.city || "").trim();
      const zip = (addr.zip || "").toString().trim();
      let result = buscarCodigoDane(city, addr.province, addr.province_code);
      if (!result && zip) result = zip;
      console.log('[getRecipientCity] addr:', addr);
      console.log('[getRecipientCity] city:', city, '| zip:', zip, '| resultado:', result);
      return result;
    },
    async calculateShipping() {
      if (!this.order) return;
      this.isCalculatingShipping = true;
      this.shippingError = "";
      try {
        const recipientCity = this.getRecipientCity(this.shippingFormAddress());
        const orderLabel = this.orderLabel(this.order);
        const payload = {
          shopify_order_id: this.order.id,
          sender_city: "54001000",
          recipient_city: recipientCity,
          package_detail: this.buildPackageDetail(),
          charge_shipping_to_customer: this.chargeShippingToCustomer,
          payment_method: this.shippingPaymentMethod,
          package_type: "Paquetes",
          notes: orderLabel,
          external_id: `shp-${orderLabel}`,
        };
        const response = await shopifyService.calculateShipping(payload);
        const data = response?.data?.data ?? response?.data ?? {};
        this.shippingOptions = Array.isArray(data) ? data : (data.options || data.results || (Object.keys(data).length ? [data] : []));
      } catch (error) {
        this.shippingError = error?.response?.data?.message || "Error al calcular el envío.";
        this.shippingOptions = [];
      } finally {
        this.isCalculatingShipping = false;
        this.hasCalculatedShipping = true;
      }
    },
    async generateTicket() {
      if (!this.order || this.selectedShippingOption === null) return;

      const addr = this.shippingFormAddress();
      if (await this.blockDefaultPackageDimensions(addr)) return;
      const province = (addr.province || addr.province_code || '').trim();
      const selectedOpt = this.shippingOptions[this.selectedShippingOption] || {};

      // Validación: si la provincia es Bogotá, D.C., pedir confirmación para revisar la dirección
      if (/bogot[aá]\s*,?\s*d\.?c\.?/i.test(province)) {
        const confirm = await Swal.fire({
          icon: 'warning',
          title: 'Revisar dirección de envío',
          html: `La provincia aparece como <b>${province}</b>.<br>Verifica que la dirección de envío sea correcta antes de continuar.`,
          showCancelButton: true,
          confirmButtonText: 'Continuar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true,
        });
        if (!confirm.isConfirmed) {
          return;
        }
      }

      this.isGeneratingWaybill = true;
      // Se abre la pestaña ya (mientras hay gesto del usuario) para que el
      // bloqueador de popups no impida mostrar el rótulo al terminar.
      const pdfWindow = this.openPendingPdfWindow();
      try {
        const customer = this.order.customer || {};
        const recipientCity = this.getRecipientCity(addr);
        const stateCode = recipientCity
          ? recipientCity.substring(0, 2)
          : (addr.province_code || addr.province || '').substring(0, 2);
        const payload = {
          shopify_order_id: this.order.id,
          sender: {
            address: {
              street: "AV 5 # 5 - 63, SEXTO PISO, BARRIO LATINO",
              city: "54001000",
              neighborhood: "",
              state: "54",
              country: "CO",
            },
          },
          receiver: {
            name: this.order.customer_name || [addr.first_name, addr.last_name].filter(Boolean).join(' ') || 'Cliente',
            address: {
              street: addr.address1 || 'sin dirección',
              city: recipientCity,
              neighborhood: "",
              state: stateCode || "54",
              country: addr.country_code || "CO",
            },
            email: this.order.email || customer.email || '',
            document_type: "CC",
            document_number: addr.company || "10000000",
            phone: addr.phone || customer.phone || '',
          },
          package_type: "Paquetes",
          package_details: this.buildPackageDetail(),
          payment_method: this.shippingPaymentMethod,
          status: "Aceptado",
          charge_shipping_to_customer: this.chargeShippingToCustomer,
          notes: this.orderLabel(this.order),
          external_id: `shp-${this.orderLabel(this.order)}`,
          carrier_id: selectedOpt.carrier_id || undefined,
          shipping_method: selectedOpt.carrier_id || undefined,
          shipping_cost: selectedOpt.price || selectedOpt.total || 0,
        };
        const response = await shopifyService.generateWaybill(payload);
        console.log('[generateWaybill] response.data:', response?.data);
        const data = response?.data?.data ?? response?.data ?? {};
        console.log('[generateWaybill] data extraído:', data);
        const waybillId = data.id;
        console.log('[generateWaybill] waybillId:', waybillId);
        // El backend pasa el pedido a GUIA GENERADA al crear la guía.
        if (Array.isArray(response?.data?.status_history)) {
          this.order.status_history = response.data.status_history;
        }
        if (response?.data?.current_status) {
          this.order.fulfillment_status = response.data.current_status;
        }
        if (waybillId) {
          this.order.picking_json = data;
          // Mismo dato que guarda el backend en waybill_package.
          const pkg = payload.package_details[0];
          this.order.waybill_package = {
            weight: pkg.weight,
            length: pkg.dimensions.length,
            width: pkg.dimensions.width,
            height: pkg.dimensions.height,
            generated_at: new Date().toISOString(),
          };
          Swal.fire({
            icon: 'success',
            title: 'Guía generada',
            text: 'La guía de envío se generó correctamente.',
            timer: 2500,
            showConfirmButton: false,
          });
          this.closeShippingModal();
          // Igual que "Imprimir rótulo": abrir el PDF del rótulo
          await this.printWaybill(pdfWindow);
          return;
        } else {
          if (pdfWindow) pdfWindow.close();
          Swal.fire({
            icon: 'success',
            title: 'Guía generada',
            text: 'La guía de envío se generó correctamente, pero no se obtuvo el ID del rótulo.',
            timer: 2500,
            showConfirmButton: false,
          });
        }
        this.closeShippingModal();
      } catch (error) {
        if (pdfWindow) pdfWindow.close();
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudo generar la guía de envío.',
        });
      } finally {
        this.isGeneratingWaybill = false;
      }
    },
    openPendingPdfWindow() {
      const win = window.open('', '_blank');
      if (win) {
        win.document.title = 'Generando rótulo...';
        win.document.body.innerHTML = '<p style="font-family:sans-serif;padding:16px">Generando rótulo...</p>';
      }
      return win;
    },
    async printWaybill(targetWindow = null) {
      // Si llega desde el @click, el argumento es el evento, no una ventana
      const pdfWindow = targetWindow && targetWindow.document ? targetWindow : null;
      if (!this.hasWaybill) {
        if (pdfWindow) pdfWindow.close();
        return;
      }
      this.isPrintingWaybill = true;
      try {
        const pdfResponse = await shopifyService.getWaybillPdf([this.waybillId]);
        console.log('[printWaybill] response.data:', pdfResponse?.data);
        const pdfData = pdfResponse?.data?.data ?? null;
        console.log('[printWaybill] pdfData (primeros 100 chars):', pdfData ? pdfData.substring(0, 100) : null);
        if (pdfData) {
          const pdfBlob = this.base64ToBlob(pdfData, 'application/pdf');
          const pdfUrl = URL.createObjectURL(pdfBlob);
          console.log('[printWaybill] abriendo PDF en nueva pestaña:', pdfUrl);
          if (pdfWindow && !pdfWindow.closed) {
            pdfWindow.location.href = pdfUrl;
          } else {
            window.open(pdfUrl, '_blank');
          }
        } else {
          if (pdfWindow) pdfWindow.close();
          Swal.fire({
            icon: 'warning',
            title: 'Sin rótulo',
            text: 'No se recibió el PDF del rótulo.',
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudo obtener el rótulo.',
        });
        if (pdfWindow) pdfWindow.close();
      } finally {
        this.isPrintingWaybill = false;
      }
    },
    base64ToBlob(base64, contentType = '') {
      const byteCharacters = atob(base64);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
      }
      return new Blob(byteArrays, { type: contentType });
    },
    formatMoney(value, currency = "COP") {
      if (value == null) return "—";
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: currency || "COP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(value);
    },
    formatDate(value) {
      if (!value) return "—";
      return new Date(value).toLocaleString("es-CO", {
        dateStyle: "short",
        timeStyle: "short",
      });
    },
    openCustomerEditModal() {
      const customer = this.order?.customer || {};
      this.customerEditForm = {
        customer_name: this.order?.customer_name || "",
        email: this.order?.email || "",
        phone: customer.phone || "",
      };
      this.showCustomerEditModal = true;
    },
    closeCustomerEditModal() {
      this.showCustomerEditModal = false;
    },
    async saveCustomer() {
      if (!this.order) return;
      this.isSavingCustomer = true;
      try {
        const response = await shopifyService.updateCustomer(this.order.id, this.customerEditForm);
        const updated = response?.data?.data;
        if (updated) {
          this.order = {
            ...this.order,
            customer_name: updated.customer_name,
            email: updated.email,
            customer: updated.customer,
          };
        }
        this.showCustomerEditModal = false;
        Swal.fire({
          icon: 'success',
          title: 'Cliente actualizado',
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error('Error al guardar cliente:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo actualizar el cliente.',
        });
      } finally {
        this.isSavingCustomer = false;
      }
    },
    openAddressEditModal() {
      const addr = this.order?.shipping_address || {};
      this.addressEditForm = {
        first_name: addr.first_name || "",
        last_name: addr.last_name || "",
        address1: addr.address1 || "",
        address2: addr.address2 || "",
        city: addr.city || "",
        province: addr.province || "",
        country: addr.country || "",
        zip: addr.zip || "",
        phone: addr.phone || "",
      };
      this.showAddressEditModal = true;
    },
    closeAddressEditModal() {
      this.showAddressEditModal = false;
    },
    async saveAddress() {
      if (!this.order) return;
      this.isSavingAddress = true;
      try {
        const response = await shopifyService.updateShippingAddress(this.order.id, this.addressEditForm);
        const updated = response?.data?.data;
        if (updated) {
          this.order = { ...this.order, shipping_address: updated };
          this.initShippingForm();
        }
        this.showAddressEditModal = false;
        Swal.fire({
          icon: 'success',
          title: 'Dirección actualizada',
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error('Error al guardar dirección:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo actualizar la dirección.',
        });
      } finally {
        this.isSavingAddress = false;
      }
    },
  },
};
</script>

<style scoped>
/* ---- Picking Packing Modal ---- */
/* Móvil: la columna Producto hace salto de línea y el resto se compacta
   para que la tabla quepa sin scroll horizontal. */
.order-items-table-mobile th,
.order-items-table-mobile td {
  padding: 0.5rem 0.3rem;
}
.order-items-table-mobile td:first-child {
  white-space: normal;
  word-break: break-word;
  min-width: 150px;
}
.order-items-table-mobile td:first-child .text-sm {
  font-size: 0.8rem !important;
  line-height: 1.25;
}
.order-items-table-mobile td:not(:first-child) {
  font-size: 0.75rem !important;
}
.order-items-table-mobile .badge {
  font-size: 0.6rem;
  padding: 0.3em 0.5em;
}

.scanner-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  /* Por encima del modal de picking (z-index 9999) */
  z-index: 10050;
}

.scanner-modal {
  width: 100%;
  max-width: 400px;
  margin: 1rem;
}

.scanner-video-wrapper {
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background: #000;
}

.scanner-video-wrapper video {
  width: 100%;
  height: auto;
  display: block;
}

.scanner-guide {
  position: absolute;
  left: 8%;
  right: 8%;
  top: 50%;
  height: 30%;
  transform: translateY(-50%);
  border: 2px solid rgba(255, 255, 255, 0.8);
  border-radius: 6px;
  pointer-events: none;
}

.picking-modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.picking-modal-box {
  background: #fff;
  border-radius: 16px;
  max-width: 480px;
  width: 90%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}
.picking-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  border-bottom: 1px solid #e9ecef;
}
.picking-modal-header h5 {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}
.picking-modal-body {
  padding: 20px 24px;
  overflow-y: auto;
  flex: 1;
}
.order-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 16px;
}
.order-info-grid > div {
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-break: break-word;
}
.order-info-full {
  grid-column: 1 / -1;
}
.card-toggle {
  cursor: pointer;
  user-select: none;
}

.order-info-label {
  font-size: 0.7rem;
  color: #8392ab;
  line-height: 1.2;
}
.location-info-row {
  margin-bottom: 10px;
  line-height: 1.5;
}
.location-info-row:last-child {
  margin-bottom: 0;
}
.picking-modal-footer {
  padding: 14px 24px;
  border-top: 1px solid #e9ecef;
}
.picking-scan-input-wrapper {
  display: flex;
  gap: 8px;
}
.picking-scan-input {
  flex: 1;
  font-size: 15px;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 14px;
  height: 44px;
  box-sizing: border-box;
}
.picking-scan-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
  outline: none;
}
.picking-scan-btn {
  border-radius: 8px;
  padding: 0 16px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.picking-scan-message {
  margin-top: 12px;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}
.picking-scan-message.success {
  background: #d1fae5;
  color: #065f46;
}
.picking-scan-message.error {
  background: #fee2e2;
  color: #991b1b;
}
.picking-items-list {
  max-height: 460px;
  overflow-y: auto;
}
.picking-item-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  margin-bottom: 6px;
  background: #f9fafb;
  transition: background 0.2s;
}
.picking-item-row.picking-item-picked {
  background: #ecfdf5;
}
.shipping-option-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  border-radius: 8px;
  margin-bottom: 6px;
  background: #f9fafb;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.2s;
}
.shipping-option-row:hover {
  background: #eff6ff;
}
.shipping-option-selected {
  border-color: #2563eb;
  background: #eff6ff;
}
</style>
